// DONT EDIT THIS FILE. AUTOGENERATED. 
export var ActivityModalTKeys;
(function (ActivityModalTKeys) {
    ActivityModalTKeys["activity"] = "ActivityModal.activity";
    ActivityModalTKeys["applyFilter"] = "ActivityModal.applyFilter";
    ActivityModalTKeys["filterByDateRange"] = "ActivityModal.filterByDateRange";
    ActivityModalTKeys["filterByMachine"] = "ActivityModal.filterByMachine";
    ActivityModalTKeys["filterByViolationType"] = "ActivityModal.filterByViolationType";
    ActivityModalTKeys["filteredActivityResults"] = "ActivityModal.filteredActivityResults";
})(ActivityModalTKeys || (ActivityModalTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var AddRequestModalTKeys;
(function (AddRequestModalTKeys) {
    AddRequestModalTKeys["CSV"] = "AddRequestModal.CSV";
    AddRequestModalTKeys["Excel"] = "AddRequestModal.Excel";
    AddRequestModalTKeys["addRequest"] = "AddRequestModal.addRequest";
    AddRequestModalTKeys["assignToAccount"] = "AddRequestModal.assignToAccount";
    AddRequestModalTKeys["assignToUser"] = "AddRequestModal.assignToUser";
    AddRequestModalTKeys["back"] = "AddRequestModal.back";
    AddRequestModalTKeys["cancel"] = "AddRequestModal.cancel";
    AddRequestModalTKeys["change"] = "AddRequestModal.change";
    AddRequestModalTKeys["close"] = "AddRequestModal.close";
    AddRequestModalTKeys["comments"] = "AddRequestModal.comments";
    AddRequestModalTKeys["create"] = "AddRequestModal.create";
    AddRequestModalTKeys["createdAt"] = "AddRequestModal.createdAt";
    AddRequestModalTKeys["daily"] = "AddRequestModal.daily";
    AddRequestModalTKeys["deleteDocument"] = "AddRequestModal.deleteDocument";
    AddRequestModalTKeys["demobilisation"] = "AddRequestModal.demobilisation";
    AddRequestModalTKeys["documentType"] = "AddRequestModal.documentType";
    AddRequestModalTKeys["dragToUpload"] = "AddRequestModal.dragToUpload";
    AddRequestModalTKeys["editRequest"] = "AddRequestModal.editRequest";
    AddRequestModalTKeys["errorReport"] = "AddRequestModal.errorReport";
    AddRequestModalTKeys["expiry"] = "AddRequestModal.expiry";
    AddRequestModalTKeys["extension"] = "AddRequestModal.extension";
    AddRequestModalTKeys["fillIn"] = "AddRequestModal.fillIn";
    AddRequestModalTKeys["friday"] = "AddRequestModal.friday";
    AddRequestModalTKeys["identifier"] = "AddRequestModal.identifier";
    AddRequestModalTKeys["interval"] = "AddRequestModal.interval";
    AddRequestModalTKeys["monday"] = "AddRequestModal.monday";
    AddRequestModalTKeys["monthly"] = "AddRequestModal.monthly";
    AddRequestModalTKeys["next"] = "AddRequestModal.next";
    AddRequestModalTKeys["remarks"] = "AddRequestModal.remarks";
    AddRequestModalTKeys["remarksOrComments"] = "AddRequestModal.remarksOrComments";
    AddRequestModalTKeys["remove"] = "AddRequestModal.remove";
    AddRequestModalTKeys["replacement"] = "AddRequestModal.replacement";
    AddRequestModalTKeys["requestDetails"] = "AddRequestModal.requestDetails";
    AddRequestModalTKeys["requestSuccessful"] = "AddRequestModal.requestSuccessful";
    AddRequestModalTKeys["requestType"] = "AddRequestModal.requestType";
    AddRequestModalTKeys["saturday"] = "AddRequestModal.saturday";
    AddRequestModalTKeys["save"] = "AddRequestModal.save";
    AddRequestModalTKeys["scheduling"] = "AddRequestModal.scheduling";
    AddRequestModalTKeys["selectDate"] = "AddRequestModal.selectDate";
    AddRequestModalTKeys["selectDay"] = "AddRequestModal.selectDay";
    AddRequestModalTKeys["selectDayOfMonth"] = "AddRequestModal.selectDayOfMonth";
    AddRequestModalTKeys["selectFormat"] = "AddRequestModal.selectFormat";
    AddRequestModalTKeys["selectFrequency"] = "AddRequestModal.selectFrequency";
    AddRequestModalTKeys["selectMachine"] = "AddRequestModal.selectMachine";
    AddRequestModalTKeys["selectRequired"] = "AddRequestModal.selectRequired";
    AddRequestModalTKeys["selectUsers"] = "AddRequestModal.selectUsers";
    AddRequestModalTKeys["selectUsers2"] = "AddRequestModal.selectUsers2";
    AddRequestModalTKeys["selectWeekDay"] = "AddRequestModal.selectWeekDay";
    AddRequestModalTKeys["singleOrBulk"] = "AddRequestModal.singleOrBulk";
    AddRequestModalTKeys["status"] = "AddRequestModal.status";
    AddRequestModalTKeys["sunday"] = "AddRequestModal.sunday";
    AddRequestModalTKeys["thursday"] = "AddRequestModal.thursday";
    AddRequestModalTKeys["time"] = "AddRequestModal.time";
    AddRequestModalTKeys["tuesday"] = "AddRequestModal.tuesday";
    AddRequestModalTKeys["typeOfRequest"] = "AddRequestModal.typeOfRequest";
    AddRequestModalTKeys["uploadDoc"] = "AddRequestModal.uploadDoc";
    AddRequestModalTKeys["wednesday"] = "AddRequestModal.wednesday";
    AddRequestModalTKeys["weekly"] = "AddRequestModal.weekly";
    AddRequestModalTKeys["workOrder"] = "AddRequestModal.workOrder";
})(AddRequestModalTKeys || (AddRequestModalTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var AppTKeys;
(function (AppTKeys) {
    AppTKeys["automaticallyLoggingInMessage"] = "App.automaticallyLoggingInMessage";
    AppTKeys["noPermission"] = "App.noPermission";
})(AppTKeys || (AppTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var BookMachinesPageTKeys;
(function (BookMachinesPageTKeys) {
    BookMachinesPageTKeys["action"] = "BookMachinesPage.action";
    BookMachinesPageTKeys["addToInquiry"] = "BookMachinesPage.addToInquiry";
    BookMachinesPageTKeys["anySpecialRequests"] = "BookMachinesPage.anySpecialRequests";
    BookMachinesPageTKeys["backhoes"] = "BookMachinesPage.backhoes";
    BookMachinesPageTKeys["bulldozers"] = "BookMachinesPage.bulldozers";
    BookMachinesPageTKeys["cancel"] = "BookMachinesPage.cancel";
    BookMachinesPageTKeys["cantFindMachineLookingFor"] = "BookMachinesPage.cantFindMachineLookingFor";
    BookMachinesPageTKeys["capacity"] = "BookMachinesPage.capacity";
    BookMachinesPageTKeys["comments"] = "BookMachinesPage.comments";
    BookMachinesPageTKeys["commentsRemarks"] = "BookMachinesPage.commentsRemarks";
    BookMachinesPageTKeys["crane"] = "BookMachinesPage.crane";
    BookMachinesPageTKeys["deliverInfo"] = "BookMachinesPage.deliverInfo";
    BookMachinesPageTKeys["deliveryDate"] = "BookMachinesPage.deliveryDate";
    BookMachinesPageTKeys["deliveryLocation"] = "BookMachinesPage.deliveryLocation";
    BookMachinesPageTKeys["excavators"] = "BookMachinesPage.excavators";
    BookMachinesPageTKeys["grader"] = "BookMachinesPage.grader";
    BookMachinesPageTKeys["itemAddedToInquiry"] = "BookMachinesPage.itemAddedToInquiry";
    BookMachinesPageTKeys["location"] = "BookMachinesPage.location";
    BookMachinesPageTKeys["mobileCrane"] = "BookMachinesPage.mobileCrane";
    BookMachinesPageTKeys["model"] = "BookMachinesPage.model";
    BookMachinesPageTKeys["motorGrader"] = "BookMachinesPage.motorGrader";
    BookMachinesPageTKeys["nextStep"] = "BookMachinesPage.nextStep";
    BookMachinesPageTKeys["noMoreResults"] = "BookMachinesPage.noMoreResults";
    BookMachinesPageTKeys["noResultsFound"] = "BookMachinesPage.noResultsFound";
    BookMachinesPageTKeys["orderPlacedSuccessfully"] = "BookMachinesPage.orderPlacedSuccessfully";
    BookMachinesPageTKeys["placeOrder"] = "BookMachinesPage.placeOrder";
    BookMachinesPageTKeys["popularMachines"] = "BookMachinesPage.popularMachines";
    BookMachinesPageTKeys["previousStep"] = "BookMachinesPage.previousStep";
    BookMachinesPageTKeys["priceType"] = "BookMachinesPage.priceType";
    BookMachinesPageTKeys["quantity"] = "BookMachinesPage.quantity";
    BookMachinesPageTKeys["remove"] = "BookMachinesPage.remove";
    BookMachinesPageTKeys["rock"] = "BookMachinesPage.rock";
    BookMachinesPageTKeys["sabhka"] = "BookMachinesPage.sabhka";
    BookMachinesPageTKeys["sand"] = "BookMachinesPage.sand";
    BookMachinesPageTKeys["scopeOfProject"] = "BookMachinesPage.scopeOfProject";
    BookMachinesPageTKeys["searchForYourMachineRequirements"] = "BookMachinesPage.searchForYourMachineRequirements";
    BookMachinesPageTKeys["searchMachines"] = "BookMachinesPage.searchMachines";
    BookMachinesPageTKeys["sendInquiry"] = "BookMachinesPage.sendInquiry";
    BookMachinesPageTKeys["sendUsYourInquiry"] = "BookMachinesPage.sendUsYourInquiry";
    BookMachinesPageTKeys["shoppingCart"] = "BookMachinesPage.shoppingCart";
    BookMachinesPageTKeys["shovel"] = "BookMachinesPage.shovel";
    BookMachinesPageTKeys["skidSteer"] = "BookMachinesPage.skidSteer";
    BookMachinesPageTKeys["submitInquiryNow"] = "BookMachinesPage.submitInquiryNow";
    BookMachinesPageTKeys["trackOrder"] = "BookMachinesPage.trackOrder";
    BookMachinesPageTKeys["trucks"] = "BookMachinesPage.trucks";
    BookMachinesPageTKeys["type"] = "BookMachinesPage.type";
    BookMachinesPageTKeys["viewAndCheckout"] = "BookMachinesPage.viewAndCheckout";
    BookMachinesPageTKeys["workStartDate"] = "BookMachinesPage.workStartDate";
    BookMachinesPageTKeys["youCanNowTrack"] = "BookMachinesPage.youCanNowTrack";
    BookMachinesPageTKeys["yourRequirements"] = "BookMachinesPage.yourRequirements";
})(BookMachinesPageTKeys || (BookMachinesPageTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var ButtonsTKeys;
(function (ButtonsTKeys) {
    ButtonsTKeys["confirm"] = "Buttons.confirm";
})(ButtonsTKeys || (ButtonsTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var CustomInquiryTKeys;
(function (CustomInquiryTKeys) {
    CustomInquiryTKeys["alreadyHaveAnAccount"] = "CustomInquiry.alreadyHaveAnAccount";
    CustomInquiryTKeys["cannotFindMachine"] = "CustomInquiry.cannotFindMachine";
    CustomInquiryTKeys["clickHere"] = "CustomInquiry.clickHere";
    CustomInquiryTKeys["company"] = "CustomInquiry.company";
    CustomInquiryTKeys["companyName"] = "CustomInquiry.companyName";
    CustomInquiryTKeys["daily"] = "CustomInquiry.daily";
    CustomInquiryTKeys["deliveryDate"] = "CustomInquiry.deliveryDate";
    CustomInquiryTKeys["email"] = "CustomInquiry.email";
    CustomInquiryTKeys["emailAddress"] = "CustomInquiry.emailAddress";
    CustomInquiryTKeys["fillInDetails"] = "CustomInquiry.fillInDetails";
    CustomInquiryTKeys["fullName"] = "CustomInquiry.fullName";
    CustomInquiryTKeys["getQuote"] = "CustomInquiry.getQuote";
    CustomInquiryTKeys["goBack"] = "CustomInquiry.goBack";
    CustomInquiryTKeys["location"] = "CustomInquiry.location";
    CustomInquiryTKeys["loginHere"] = "CustomInquiry.loginHere";
    CustomInquiryTKeys["monthly"] = "CustomInquiry.monthly";
    CustomInquiryTKeys["orderDetails"] = "CustomInquiry.orderDetails";
    CustomInquiryTKeys["orders"] = "CustomInquiry.orders";
    CustomInquiryTKeys["phoneNumber"] = "CustomInquiry.phoneNumber";
    CustomInquiryTKeys["pleaseEnterOTP"] = "CustomInquiry.pleaseEnterOTP";
    CustomInquiryTKeys["resendOTP"] = "CustomInquiry.resendOTP";
    CustomInquiryTKeys["search"] = "CustomInquiry.search";
    CustomInquiryTKeys["selectDeliveryDate"] = "CustomInquiry.selectDeliveryDate";
    CustomInquiryTKeys["sendUsYourInquiry"] = "CustomInquiry.sendUsYourInquiry";
    CustomInquiryTKeys["verifyOTP"] = "CustomInquiry.verifyOTP";
    CustomInquiryTKeys["weekly"] = "CustomInquiry.weekly";
    CustomInquiryTKeys["yearly"] = "CustomInquiry.yearly";
})(CustomInquiryTKeys || (CustomInquiryTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var EditMaintenanceHistoryModalTKeys;
(function (EditMaintenanceHistoryModalTKeys) {
    EditMaintenanceHistoryModalTKeys["amountSpent"] = "EditMaintenanceHistoryModal.amountSpent";
    EditMaintenanceHistoryModalTKeys["attachments"] = "EditMaintenanceHistoryModal.attachments";
    EditMaintenanceHistoryModalTKeys["cancel"] = "EditMaintenanceHistoryModal.cancel";
    EditMaintenanceHistoryModalTKeys["comments"] = "EditMaintenanceHistoryModal.comments";
    EditMaintenanceHistoryModalTKeys["completed"] = "EditMaintenanceHistoryModal.completed";
    EditMaintenanceHistoryModalTKeys["edit"] = "EditMaintenanceHistoryModal.edit";
    EditMaintenanceHistoryModalTKeys["editMaintenanceHistory"] = "EditMaintenanceHistoryModal.editMaintenanceHistory";
    EditMaintenanceHistoryModalTKeys["markAsCompleted"] = "EditMaintenanceHistoryModal.markAsCompleted";
    EditMaintenanceHistoryModalTKeys["pending"] = "EditMaintenanceHistoryModal.pending";
    EditMaintenanceHistoryModalTKeys["saveChanges"] = "EditMaintenanceHistoryModal.saveChanges";
    EditMaintenanceHistoryModalTKeys["selectCompleted"] = "EditMaintenanceHistoryModal.selectCompleted";
    EditMaintenanceHistoryModalTKeys["youCanSetup"] = "EditMaintenanceHistoryModal.youCanSetup";
})(EditMaintenanceHistoryModalTKeys || (EditMaintenanceHistoryModalTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var EquipmentTypeTKeys;
(function (EquipmentTypeTKeys) {
    EquipmentTypeTKeys["air_compressor"] = "EquipmentType.air_compressor";
    EquipmentTypeTKeys["all_machines"] = "EquipmentType.all_machines";
    EquipmentTypeTKeys["all_terrain_crane"] = "EquipmentType.all_terrain_crane";
    EquipmentTypeTKeys["angle_grinder"] = "EquipmentType.angle_grinder";
    EquipmentTypeTKeys["arc_welding_machine"] = "EquipmentType.arc_welding_machine";
    EquipmentTypeTKeys["articulated_dump_truck"] = "EquipmentType.articulated_dump_truck";
    EquipmentTypeTKeys["asphalt_paver_machine"] = "EquipmentType.asphalt_paver_machine";
    EquipmentTypeTKeys["asphalt_saw_cutter"] = "EquipmentType.asphalt_saw_cutter";
    EquipmentTypeTKeys["asphalt_team"] = "EquipmentType.asphalt_team";
    EquipmentTypeTKeys["backhoe_loader"] = "EquipmentType.backhoe_loader";
    EquipmentTypeTKeys["bitumen_tanker"] = "EquipmentType.bitumen_tanker";
    EquipmentTypeTKeys["boom_lift"] = "EquipmentType.boom_lift";
    EquipmentTypeTKeys["boom_loader"] = "EquipmentType.boom_loader";
    EquipmentTypeTKeys["boom_truck"] = "EquipmentType.boom_truck";
    EquipmentTypeTKeys["boom_truck_winch"] = "EquipmentType.boom_truck_winch";
    EquipmentTypeTKeys["box_truck"] = "EquipmentType.box_truck";
    EquipmentTypeTKeys["bulldozer"] = "EquipmentType.bulldozer";
    EquipmentTypeTKeys["bundle_puller"] = "EquipmentType.bundle_puller";
    EquipmentTypeTKeys["bus"] = "EquipmentType.bus";
    EquipmentTypeTKeys["cement_mixer"] = "EquipmentType.cement_mixer";
    EquipmentTypeTKeys["chain_saw"] = "EquipmentType.chain_saw";
    EquipmentTypeTKeys["cng_skid"] = "EquipmentType.cng_skid";
    EquipmentTypeTKeys["concrete_polishing_machine"] = "EquipmentType.concrete_polishing_machine";
    EquipmentTypeTKeys["concrete_pump"] = "EquipmentType.concrete_pump";
    EquipmentTypeTKeys["concrete_vibrator_electric"] = "EquipmentType.concrete_vibrator_electric";
    EquipmentTypeTKeys["concrete_vibrator_petrol"] = "EquipmentType.concrete_vibrator_petrol";
    EquipmentTypeTKeys["construction_barge"] = "EquipmentType.construction_barge";
    EquipmentTypeTKeys["crawler_crane"] = "EquipmentType.crawler_crane";
    EquipmentTypeTKeys["diesel_tanker"] = "EquipmentType.diesel_tanker";
    EquipmentTypeTKeys["double_drum_roller"] = "EquipmentType.double_drum_roller";
    EquipmentTypeTKeys["dump_truck"] = "EquipmentType.dump_truck";
    EquipmentTypeTKeys["excavator_attachment"] = "EquipmentType.excavator_attachment";
    EquipmentTypeTKeys["excavator_crawler"] = "EquipmentType.excavator_crawler";
    EquipmentTypeTKeys["excavator_crawler_jackhammer"] = "EquipmentType.excavator_crawler_jackhammer";
    EquipmentTypeTKeys["excavator_long_boom"] = "EquipmentType.excavator_long_boom";
    EquipmentTypeTKeys["excavator_wheel"] = "EquipmentType.excavator_wheel";
    EquipmentTypeTKeys["flat_top_barge"] = "EquipmentType.flat_top_barge";
    EquipmentTypeTKeys["flatbed"] = "EquipmentType.flatbed";
    EquipmentTypeTKeys["forklift"] = "EquipmentType.forklift";
    EquipmentTypeTKeys["generator"] = "EquipmentType.generator";
    EquipmentTypeTKeys["goBack"] = "EquipmentType.goBack";
    EquipmentTypeTKeys["grouting_machine"] = "EquipmentType.grouting_machine";
    EquipmentTypeTKeys["hiab_crane"] = "EquipmentType.hiab_crane";
    EquipmentTypeTKeys["industrial_vacuum_cleaner"] = "EquipmentType.industrial_vacuum_cleaner";
    EquipmentTypeTKeys["jack_hammer"] = "EquipmentType.jack_hammer";
    EquipmentTypeTKeys["jig_saw"] = "EquipmentType.jig_saw";
    EquipmentTypeTKeys["laser_scanner"] = "EquipmentType.laser_scanner";
    EquipmentTypeTKeys["lifting_cradle"] = "EquipmentType.lifting_cradle";
    EquipmentTypeTKeys["lighting_tower"] = "EquipmentType.lighting_tower";
    EquipmentTypeTKeys["loadbank"] = "EquipmentType.loadbank";
    EquipmentTypeTKeys["lowbed"] = "EquipmentType.lowbed";
    EquipmentTypeTKeys["machineNotFound"] = "EquipmentType.machineNotFound";
    EquipmentTypeTKeys["machineNotFoundDesc"] = "EquipmentType.machineNotFoundDesc";
    EquipmentTypeTKeys["man_lift"] = "EquipmentType.man_lift";
    EquipmentTypeTKeys["marble_cutter"] = "EquipmentType.marble_cutter";
    EquipmentTypeTKeys["milling_machine"] = "EquipmentType.milling_machine";
    EquipmentTypeTKeys["mixokret_machine"] = "EquipmentType.mixokret_machine";
    EquipmentTypeTKeys["mobile_rock_crusher"] = "EquipmentType.mobile_rock_crusher";
    EquipmentTypeTKeys["mobile_tire_crane"] = "EquipmentType.mobile_tire_crane";
    EquipmentTypeTKeys["motor_grader"] = "EquipmentType.motor_grader";
    EquipmentTypeTKeys["over_head_crane"] = "EquipmentType.over_head_crane";
    EquipmentTypeTKeys["pickup_truck"] = "EquipmentType.pickup_truck";
    EquipmentTypeTKeys["piiling_machine"] = "EquipmentType.piiling_machine";
    EquipmentTypeTKeys["pipe_layer"] = "EquipmentType.pipe_layer";
    EquipmentTypeTKeys["plastering_machine"] = "EquipmentType.plastering_machine";
    EquipmentTypeTKeys["plate_compactor"] = "EquipmentType.plate_compactor";
    EquipmentTypeTKeys["pneumatic_tyred_roller"] = "EquipmentType.pneumatic_tyred_roller";
    EquipmentTypeTKeys["power_pallet_truck"] = "EquipmentType.power_pallet_truck";
    EquipmentTypeTKeys["power_tower"] = "EquipmentType.power_tower";
    EquipmentTypeTKeys["power_trowel"] = "EquipmentType.power_trowel";
    EquipmentTypeTKeys["ppr_machine"] = "EquipmentType.ppr_machine";
    EquipmentTypeTKeys["push_barge"] = "EquipmentType.push_barge";
    EquipmentTypeTKeys["reach_truck"] = "EquipmentType.reach_truck";
    EquipmentTypeTKeys["recovery_truck"] = "EquipmentType.recovery_truck";
    EquipmentTypeTKeys["refrigerated_truck"] = "EquipmentType.refrigerated_truck";
    EquipmentTypeTKeys["refrigerated_van"] = "EquipmentType.refrigerated_van";
    EquipmentTypeTKeys["ride_on_roller"] = "EquipmentType.ride_on_roller";
    EquipmentTypeTKeys["ride_on_scrubber"] = "EquipmentType.ride_on_scrubber";
    EquipmentTypeTKeys["rigid_truck"] = "EquipmentType.rigid_truck";
    EquipmentTypeTKeys["rough_terrain_crane"] = "EquipmentType.rough_terrain_crane";
    EquipmentTypeTKeys["scissor_lift"] = "EquipmentType.scissor_lift";
    EquipmentTypeTKeys["single_drum_roller"] = "EquipmentType.single_drum_roller";
    EquipmentTypeTKeys["skid_steer_loader"] = "EquipmentType.skid_steer_loader";
    EquipmentTypeTKeys["skip_loader"] = "EquipmentType.skip_loader";
    EquipmentTypeTKeys["spider_crane"] = "EquipmentType.spider_crane";
    EquipmentTypeTKeys["spider_lift"] = "EquipmentType.spider_lift";
    EquipmentTypeTKeys["stabilizer"] = "EquipmentType.stabilizer";
    EquipmentTypeTKeys["stacker"] = "EquipmentType.stacker";
    EquipmentTypeTKeys["stationary_concrete_pump"] = "EquipmentType.stationary_concrete_pump";
    EquipmentTypeTKeys["submersible_pump"] = "EquipmentType.submersible_pump";
    EquipmentTypeTKeys["super_sucker"] = "EquipmentType.super_sucker";
    EquipmentTypeTKeys["sweet_water_tanker"] = "EquipmentType.sweet_water_tanker";
    EquipmentTypeTKeys["tower_crane"] = "EquipmentType.tower_crane";
    EquipmentTypeTKeys["trailer"] = "EquipmentType.trailer";
    EquipmentTypeTKeys["trencher"] = "EquipmentType.trencher";
    EquipmentTypeTKeys["truck_mounted_man_lift"] = "EquipmentType.truck_mounted_man_lift";
    EquipmentTypeTKeys["tug_boat"] = "EquipmentType.tug_boat";
    EquipmentTypeTKeys["vacuum_tanker"] = "EquipmentType.vacuum_tanker";
    EquipmentTypeTKeys["van"] = "EquipmentType.van";
    EquipmentTypeTKeys["vertical_lift"] = "EquipmentType.vertical_lift";
    EquipmentTypeTKeys["walk_behind_compactor"] = "EquipmentType.walk_behind_compactor";
    EquipmentTypeTKeys["waste_water_tanker"] = "EquipmentType.waste_water_tanker";
    EquipmentTypeTKeys["water_tanker"] = "EquipmentType.water_tanker";
    EquipmentTypeTKeys["wheel_loader_shovel"] = "EquipmentType.wheel_loader_shovel";
})(EquipmentTypeTKeys || (EquipmentTypeTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var FuelDashboardTKeys;
(function (FuelDashboardTKeys) {
    FuelDashboardTKeys["capacity"] = "FuelDashboard.capacity";
    FuelDashboardTKeys["consumed"] = "FuelDashboard.consumed";
    FuelDashboardTKeys["currentLevel"] = "FuelDashboard.currentLevel";
    FuelDashboardTKeys["failedToFetchFuelEvent"] = "FuelDashboard.failedToFetchFuelEvent";
    FuelDashboardTKeys["fuelDashboard"] = "FuelDashboard.fuelDashboard";
    FuelDashboardTKeys["fuelEvents"] = "FuelDashboard.fuelEvents";
    FuelDashboardTKeys["fuelHistory"] = "FuelDashboard.fuelHistory";
    FuelDashboardTKeys["liters"] = "FuelDashboard.liters";
    FuelDashboardTKeys["loadingFuelData"] = "FuelDashboard.loadingFuelData";
    FuelDashboardTKeys["loadingFuelEvents"] = "FuelDashboard.loadingFuelEvents";
    FuelDashboardTKeys["loadingFuelHistory"] = "FuelDashboard.loadingFuelHistory";
    FuelDashboardTKeys["noFuelEvent"] = "FuelDashboard.noFuelEvent";
    FuelDashboardTKeys["noStationaryTanks"] = "FuelDashboard.noStationaryTanks";
    FuelDashboardTKeys["refilled"] = "FuelDashboard.refilled";
})(FuelDashboardTKeys || (FuelDashboardTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var GroupAlertsTKeys;
(function (GroupAlertsTKeys) {
    GroupAlertsTKeys["email"] = "GroupAlerts.email";
    GroupAlertsTKeys["equipmentMaintenance"] = "GroupAlerts.equipmentMaintenance";
    GroupAlertsTKeys["fuelTheft"] = "GroupAlerts.fuelTheft";
    GroupAlertsTKeys["geofence"] = "GroupAlerts.geofence";
    GroupAlertsTKeys["harshDriving"] = "GroupAlerts.harshDriving";
    GroupAlertsTKeys["idling"] = "GroupAlerts.idling";
    GroupAlertsTKeys["overspeeding"] = "GroupAlerts.overspeeding";
    GroupAlertsTKeys["push"] = "GroupAlerts.push";
    GroupAlertsTKeys["selectUser"] = "GroupAlerts.selectUser";
    GroupAlertsTKeys["sms"] = "GroupAlerts.sms";
    GroupAlertsTKeys["timesheet"] = "GroupAlerts.timesheet";
    GroupAlertsTKeys["updatedSuccessfully"] = "GroupAlerts.updatedSuccessfully";
})(GroupAlertsTKeys || (GroupAlertsTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var GroupAnalyticsNewTKeys;
(function (GroupAnalyticsNewTKeys) {
    GroupAnalyticsNewTKeys["analytics"] = "GroupAnalyticsNew.analytics";
    GroupAnalyticsNewTKeys["avgIdleMinutes"] = "GroupAnalyticsNew.avgIdleMinutes";
    GroupAnalyticsNewTKeys["avgRunHours"] = "GroupAnalyticsNew.avgRunHours";
    GroupAnalyticsNewTKeys["avgUtilisation"] = "GroupAnalyticsNew.avgUtilisation";
    GroupAnalyticsNewTKeys["avgUtilisationEngineOn"] = "GroupAnalyticsNew.avgUtilisationEngineOn";
    GroupAnalyticsNewTKeys["bottom5ByIdle"] = "GroupAnalyticsNew.bottom5ByIdle";
    GroupAnalyticsNewTKeys["bottom5ByNumberOfViolations"] = "GroupAnalyticsNew.bottom5ByNumberOfViolations";
    GroupAnalyticsNewTKeys["breakdown"] = "GroupAnalyticsNew.breakdown";
    GroupAnalyticsNewTKeys["custom"] = "GroupAnalyticsNew.custom";
    GroupAnalyticsNewTKeys["day"] = "GroupAnalyticsNew.day";
    GroupAnalyticsNewTKeys["equipmentWithGps"] = "GroupAnalyticsNew.equipmentWithGps";
    GroupAnalyticsNewTKeys["fuelConsumed"] = "GroupAnalyticsNew.fuelConsumed";
    GroupAnalyticsNewTKeys["fuelNotInstalled"] = "GroupAnalyticsNew.fuelNotInstalled";
    GroupAnalyticsNewTKeys["geoAlerts"] = "GroupAnalyticsNew.geoAlerts";
    GroupAnalyticsNewTKeys["geoin"] = "GroupAnalyticsNew.geoin";
    GroupAnalyticsNewTKeys["geoout"] = "GroupAnalyticsNew.geoout";
    GroupAnalyticsNewTKeys["harshDriving"] = "GroupAnalyticsNew.harshDriving";
    GroupAnalyticsNewTKeys["higherUtilisationIsBetter"] = "GroupAnalyticsNew.higherUtilisationIsBetter";
    GroupAnalyticsNewTKeys["hours"] = "GroupAnalyticsNew.hours";
    GroupAnalyticsNewTKeys["idlingMeaning"] = "GroupAnalyticsNew.idlingMeaning";
    GroupAnalyticsNewTKeys["last24hours"] = "GroupAnalyticsNew.last24hours";
    GroupAnalyticsNewTKeys["last30days"] = "GroupAnalyticsNew.last30days";
    GroupAnalyticsNewTKeys["last7days"] = "GroupAnalyticsNew.last7days";
    GroupAnalyticsNewTKeys["lowerIdleMinutesIsBetter"] = "GroupAnalyticsNew.lowerIdleMinutesIsBetter";
    GroupAnalyticsNewTKeys["machine"] = "GroupAnalyticsNew.machine";
    GroupAnalyticsNewTKeys["machineTypesByAverage"] = "GroupAnalyticsNew.machineTypesByAverage";
    GroupAnalyticsNewTKeys["machinesInterpolated"] = "GroupAnalyticsNew.machinesInterpolated";
    GroupAnalyticsNewTKeys["minutes"] = "GroupAnalyticsNew.minutes";
    GroupAnalyticsNewTKeys["numberOfMachineByType"] = "GroupAnalyticsNew.numberOfMachineByType";
    GroupAnalyticsNewTKeys["overspeed"] = "GroupAnalyticsNew.overspeed";
    GroupAnalyticsNewTKeys["overtimeStatistics"] = "GroupAnalyticsNew.overtimeStatistics";
    GroupAnalyticsNewTKeys["projectStatistics"] = "GroupAnalyticsNew.projectStatistics";
    GroupAnalyticsNewTKeys["repaired"] = "GroupAnalyticsNew.repaired";
    GroupAnalyticsNewTKeys["telematicsHours"] = "GroupAnalyticsNew.telematicsHours";
    GroupAnalyticsNewTKeys["timesMachinesExceeded"] = "GroupAnalyticsNew.timesMachinesExceeded";
    GroupAnalyticsNewTKeys["top5ByUti"] = "GroupAnalyticsNew.top5ByUti";
    GroupAnalyticsNewTKeys["total"] = "GroupAnalyticsNew.total";
    GroupAnalyticsNewTKeys["totalBreakdownByOutcome"] = "GroupAnalyticsNew.totalBreakdownByOutcome";
    GroupAnalyticsNewTKeys["totalInterpolated"] = "GroupAnalyticsNew.totalInterpolated";
    GroupAnalyticsNewTKeys["totalNumberOfViolations"] = "GroupAnalyticsNew.totalNumberOfViolations";
    GroupAnalyticsNewTKeys["totalOvertime"] = "GroupAnalyticsNew.totalOvertime";
    GroupAnalyticsNewTKeys["totalViolationByType"] = "GroupAnalyticsNew.totalViolationByType";
    GroupAnalyticsNewTKeys["utilisationMeaning"] = "GroupAnalyticsNew.utilisationMeaning";
    GroupAnalyticsNewTKeys["violationStatistics"] = "GroupAnalyticsNew.violationStatistics";
    GroupAnalyticsNewTKeys["violationType"] = "GroupAnalyticsNew.violationType";
})(GroupAnalyticsNewTKeys || (GroupAnalyticsNewTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var GroupAnalyticsPageTKeys;
(function (GroupAnalyticsPageTKeys) {
    GroupAnalyticsPageTKeys["awaitingMob"] = "GroupAnalyticsPage.awaitingMob";
    GroupAnalyticsPageTKeys["machineStatus"] = "GroupAnalyticsPage.machineStatus";
    GroupAnalyticsPageTKeys["machineTypes"] = "GroupAnalyticsPage.machineTypes";
    GroupAnalyticsPageTKeys["machines"] = "GroupAnalyticsPage.machines";
    GroupAnalyticsPageTKeys["underRepair"] = "GroupAnalyticsPage.underRepair";
})(GroupAnalyticsPageTKeys || (GroupAnalyticsPageTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var GroupMachinesPageTKeys;
(function (GroupMachinesPageTKeys) {
    GroupMachinesPageTKeys["action"] = "GroupMachinesPage.action";
    GroupMachinesPageTKeys["addMachine"] = "GroupMachinesPage.addMachine";
    GroupMachinesPageTKeys["areYouSure"] = "GroupMachinesPage.areYouSure";
    GroupMachinesPageTKeys["cancel"] = "GroupMachinesPage.cancel";
    GroupMachinesPageTKeys["create"] = "GroupMachinesPage.create";
    GroupMachinesPageTKeys["createRequest"] = "GroupMachinesPage.createRequest";
    GroupMachinesPageTKeys["delete"] = "GroupMachinesPage.delete";
    GroupMachinesPageTKeys["equipment"] = "GroupMachinesPage.equipment";
    GroupMachinesPageTKeys["equpimentAdded"] = "GroupMachinesPage.equpimentAdded";
    GroupMachinesPageTKeys["ignition"] = "GroupMachinesPage.ignition";
    GroupMachinesPageTKeys["installed"] = "GroupMachinesPage.installed";
    GroupMachinesPageTKeys["maintenanceSchedule"] = "GroupMachinesPage.maintenanceSchedule";
    GroupMachinesPageTKeys["model"] = "GroupMachinesPage.model";
    GroupMachinesPageTKeys["notInstalled"] = "GroupMachinesPage.notInstalled";
    GroupMachinesPageTKeys["numberPlate"] = "GroupMachinesPage.numberPlate";
    GroupMachinesPageTKeys["selectEquipment"] = "GroupMachinesPage.selectEquipment";
    GroupMachinesPageTKeys["speed"] = "GroupMachinesPage.speed";
    GroupMachinesPageTKeys["status"] = "GroupMachinesPage.status";
    GroupMachinesPageTKeys["successfullyRemoved"] = "GroupMachinesPage.successfullyRemoved";
    GroupMachinesPageTKeys["type"] = "GroupMachinesPage.type";
    GroupMachinesPageTKeys["view"] = "GroupMachinesPage.view";
    GroupMachinesPageTKeys["viewOptions"] = "GroupMachinesPage.viewOptions";
    GroupMachinesPageTKeys["year"] = "GroupMachinesPage.year";
})(GroupMachinesPageTKeys || (GroupMachinesPageTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var GroupMenuBarTKeys;
(function (GroupMenuBarTKeys) {
    GroupMenuBarTKeys["analytics"] = "GroupMenuBar.analytics";
    GroupMenuBarTKeys["emissions"] = "GroupMenuBar.emissions";
    GroupMenuBarTKeys["machines"] = "GroupMenuBar.machines";
    GroupMenuBarTKeys["masterGroup"] = "GroupMenuBar.masterGroup";
    GroupMenuBarTKeys["operators"] = "GroupMenuBar.operators";
    GroupMenuBarTKeys["project"] = "GroupMenuBar.project";
    GroupMenuBarTKeys["reports"] = "GroupMenuBar.reports";
    GroupMenuBarTKeys["requests"] = "GroupMenuBar.requests";
    GroupMenuBarTKeys["settings"] = "GroupMenuBar.settings";
    GroupMenuBarTKeys["geofences"] = "GroupMenuBar.geofences";
    GroupMenuBarTKeys["tracking"] = "GroupMenuBar.tracking";
    GroupMenuBarTKeys["yard"] = "GroupMenuBar.yard";
})(GroupMenuBarTKeys || (GroupMenuBarTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var GroupOperatorsTKeys;
(function (GroupOperatorsTKeys) {
    GroupOperatorsTKeys["Mobile"] = "GroupOperators.Mobile";
    GroupOperatorsTKeys["action"] = "GroupOperators.action";
    GroupOperatorsTKeys["addOperator"] = "GroupOperators.addOperator";
    GroupOperatorsTKeys["customId"] = "GroupOperators.customId";
    GroupOperatorsTKeys["iButton"] = "GroupOperators.iButton";
    GroupOperatorsTKeys["name"] = "GroupOperators.name";
    GroupOperatorsTKeys["operators"] = "GroupOperators.operators";
    GroupOperatorsTKeys["remarks"] = "GroupOperators.remarks";
    GroupOperatorsTKeys["searchOperators"] = "GroupOperators.searchOperators";
})(GroupOperatorsTKeys || (GroupOperatorsTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var GroupReportsPageTKeys;
(function (GroupReportsPageTKeys) {
    GroupReportsPageTKeys["addAutomatedReport"] = "GroupReportsPage.addAutomatedReport";
    GroupReportsPageTKeys["addReport"] = "GroupReportsPage.addReport";
    GroupReportsPageTKeys["automatedReports"] = "GroupReportsPage.automatedReports";
    GroupReportsPageTKeys["comprehensiveElevationReport"] = "GroupReportsPage.comprehensiveElevationReport";
    GroupReportsPageTKeys["comprehensiveElevationReportDesc"] = "GroupReportsPage.comprehensiveElevationReportDesc";
    GroupReportsPageTKeys["comprehensiveGeofenceReport"] = "GroupReportsPage.comprehensiveGeofenceReport";
    GroupReportsPageTKeys["comprehensiveGeofenceReportDesc"] = "GroupReportsPage.comprehensiveGeofenceReportDesc";
    GroupReportsPageTKeys["comprehensiveGeofenceTripReport"] = "GroupReportsPage.comprehensiveGeofenceTripReport";
    GroupReportsPageTKeys["comprehensiveIgnitionReport"] = "GroupReportsPage.comprehensiveIgnitionReport";
    GroupReportsPageTKeys["dailyFuelReport"] = "GroupReportsPage.dailyFuelReport";
    GroupReportsPageTKeys["dailyFuelReportDesc"] = "GroupReportsPage.dailyFuelReportDesc";
    GroupReportsPageTKeys["dateRangeLimit31"] = "GroupReportsPage.dateRangeLimit31";
    GroupReportsPageTKeys["days"] = "GroupReportsPage.days";
    GroupReportsPageTKeys["delete"] = "GroupReportsPage.delete";
    GroupReportsPageTKeys["deleteDoc"] = "GroupReportsPage.deleteDoc";
    GroupReportsPageTKeys["destinationProject"] = "GroupReportsPage.destinationProject";
    GroupReportsPageTKeys["downloadReport"] = "GroupReportsPage.downloadReport";
    GroupReportsPageTKeys["driverAuthentication"] = "GroupReportsPage.driverAuthentication";
    GroupReportsPageTKeys["driverAuthenticationReportDesc"] = "GroupReportsPage.driverAuthenticationReportDesc";
    GroupReportsPageTKeys["driverReport"] = "GroupReportsPage.driverReport";
    GroupReportsPageTKeys["driverReportDesc"] = "GroupReportsPage.driverReportDesc";
    GroupReportsPageTKeys["edit"] = "GroupReportsPage.edit";
    GroupReportsPageTKeys["elevationReport"] = "GroupReportsPage.elevationReport";
    GroupReportsPageTKeys["elevationReportDesc"] = "GroupReportsPage.elevationReportDesc";
    GroupReportsPageTKeys["emails"] = "GroupReportsPage.emails";
    GroupReportsPageTKeys["equipmentAllocationDesc"] = "GroupReportsPage.equipmentAllocationDesc";
    GroupReportsPageTKeys["equipmentAllocationReport"] = "GroupReportsPage.equipmentAllocationReport";
    GroupReportsPageTKeys["everyX"] = "GroupReportsPage.everyX";
    GroupReportsPageTKeys["frequency"] = "GroupReportsPage.frequency";
    GroupReportsPageTKeys["fuelEventReport"] = "GroupReportsPage.fuelEventReport";
    GroupReportsPageTKeys["fuelEventReportDesc"] = "GroupReportsPage.fuelEventReportDesc";
    GroupReportsPageTKeys["fuelSummary"] = "GroupReportsPage.fuelSummary";
    GroupReportsPageTKeys["fuelSummaryReport"] = "GroupReportsPage.fuelSummaryReport";
    GroupReportsPageTKeys["fuelSummaryReportDesc"] = "GroupReportsPage.fuelSummaryReportDesc";
    GroupReportsPageTKeys["generate"] = "GroupReportsPage.generate";
    GroupReportsPageTKeys["generateReport"] = "GroupReportsPage.generateReport";
    GroupReportsPageTKeys["generatedReports"] = "GroupReportsPage.generatedReports";
    GroupReportsPageTKeys["geoFenceErrorAlert"] = "GroupReportsPage.geoFenceErrorAlert";
    GroupReportsPageTKeys["geofenceReport"] = "GroupReportsPage.geofenceReport";
    GroupReportsPageTKeys["geofenceReportDesc"] = "GroupReportsPage.geofenceReportDesc";
    GroupReportsPageTKeys["geofenceTripReport"] = "GroupReportsPage.geofenceTripReport";
    GroupReportsPageTKeys["geofenceTripReportDesc"] = "GroupReportsPage.geofenceTripReportDesc";
    GroupReportsPageTKeys["goldMembershipReports"] = "GroupReportsPage.goldMembershipReports";
    GroupReportsPageTKeys["hours"] = "GroupReportsPage.hours";
    GroupReportsPageTKeys["idling"] = "GroupReportsPage.idling";
    GroupReportsPageTKeys["idlingReport"] = "GroupReportsPage.idlingReport";
    GroupReportsPageTKeys["idlingReportDesc"] = "GroupReportsPage.idlingReportDesc";
    GroupReportsPageTKeys["ignition"] = "GroupReportsPage.ignition";
    GroupReportsPageTKeys["ignitionFullReport"] = "GroupReportsPage.ignitionFullReport";
    GroupReportsPageTKeys["ignitionFullReportDesc"] = "GroupReportsPage.ignitionFullReportDesc";
    GroupReportsPageTKeys["ignitionReport"] = "GroupReportsPage.ignitionReport";
    GroupReportsPageTKeys["ignitionReportDesc"] = "GroupReportsPage.ignitionReportDesc";
    GroupReportsPageTKeys["kms"] = "GroupReportsPage.kms";
    GroupReportsPageTKeys["mewpReport"] = "GroupReportsPage.mewpReport";
    GroupReportsPageTKeys["mewpReportDesc"] = "GroupReportsPage.mewpReportDesc";
    GroupReportsPageTKeys["mewpServiceReport"] = "GroupReportsPage.mewpServiceReport";
    GroupReportsPageTKeys["mewpServiceReportDesc"] = "GroupReportsPage.mewpServiceReportDesc";
    GroupReportsPageTKeys["noAutomatedReports"] = "GroupReportsPage.noAutomatedReports";
    GroupReportsPageTKeys["pepsiReport"] = "GroupReportsPage.pepsiReport";
    GroupReportsPageTKeys["pepsiReportDesc"] = "GroupReportsPage.pepsiReportDesc";
    GroupReportsPageTKeys["preventativeMaintenanceReport"] = "GroupReportsPage.preventativeMaintenanceReport";
    GroupReportsPageTKeys["report"] = "GroupReportsPage.report";
    GroupReportsPageTKeys["reports"] = "GroupReportsPage.reports";
    GroupReportsPageTKeys["requestReport"] = "GroupReportsPage.requestReport";
    GroupReportsPageTKeys["requestReportDesc"] = "GroupReportsPage.requestReportDesc";
    GroupReportsPageTKeys["selectDate"] = "GroupReportsPage.selectDate";
    GroupReportsPageTKeys["selectDateRange"] = "GroupReportsPage.selectDateRange";
    GroupReportsPageTKeys["selectReportType"] = "GroupReportsPage.selectReportType";
    GroupReportsPageTKeys["skidEffeciencyReport"] = "GroupReportsPage.skidEffeciencyReport";
    GroupReportsPageTKeys["sourceProject"] = "GroupReportsPage.sourceProject";
    GroupReportsPageTKeys["summaryReport"] = "GroupReportsPage.summaryReport";
    GroupReportsPageTKeys["timesheet"] = "GroupReportsPage.timesheet";
    GroupReportsPageTKeys["timesheetReport"] = "GroupReportsPage.timesheetReport";
    GroupReportsPageTKeys["timesheetReportDesc"] = "GroupReportsPage.timesheetReportDesc";
    GroupReportsPageTKeys["tripReport"] = "GroupReportsPage.tripReport";
    GroupReportsPageTKeys["tripReportDesc"] = "GroupReportsPage.tripReportDesc";
    GroupReportsPageTKeys["unResponsiveReport"] = "GroupReportsPage.unResponsiveReport";
    GroupReportsPageTKeys["unresponseDeviceReportDesc"] = "GroupReportsPage.unresponseDeviceReportDesc";
    GroupReportsPageTKeys["updateReport"] = "GroupReportsPage.updateReport";
    GroupReportsPageTKeys["violation"] = "GroupReportsPage.violation";
    GroupReportsPageTKeys["violationsReport"] = "GroupReportsPage.violationsReport";
    GroupReportsPageTKeys["violationsReportDesc"] = "GroupReportsPage.violationsReportDesc";
    GroupReportsPageTKeys["workTimeChosenReport"] = "GroupReportsPage.workTimeChosenReport";
    GroupReportsPageTKeys["workTimeChosenReportDesc"] = "GroupReportsPage.workTimeChosenReportDesc";
    GroupReportsPageTKeys["workTimeReport"] = "GroupReportsPage.workTimeReport";
    GroupReportsPageTKeys["workTimeReportDesc"] = "GroupReportsPage.workTimeReportDesc";
    GroupReportsPageTKeys["workTimeSummary"] = "GroupReportsPage.workTimeSummary";
})(GroupReportsPageTKeys || (GroupReportsPageTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var GroupSelectionPageTKeys;
(function (GroupSelectionPageTKeys) {
    GroupSelectionPageTKeys["active"] = "GroupSelectionPage.active";
    GroupSelectionPageTKeys["createNewGroup"] = "GroupSelectionPage.createNewGroup";
    GroupSelectionPageTKeys["demobEquipments"] = "GroupSelectionPage.demobEquipments";
    GroupSelectionPageTKeys["getStarted"] = "GroupSelectionPage.getStarted";
    GroupSelectionPageTKeys["idleEquipments"] = "GroupSelectionPage.idleEquipments";
    GroupSelectionPageTKeys["manageMultipleYards"] = "GroupSelectionPage.manageMultipleYards";
    GroupSelectionPageTKeys["managedByTenderdGroups"] = "GroupSelectionPage.managedByTenderdGroups";
    GroupSelectionPageTKeys["masterGroup"] = "GroupSelectionPage.masterGroup";
    GroupSelectionPageTKeys["myProjects"] = "GroupSelectionPage.myProjects";
    GroupSelectionPageTKeys["noOfEquips"] = "GroupSelectionPage.noOfEquips";
    GroupSelectionPageTKeys["noProjects"] = "GroupSelectionPage.noProjects";
    GroupSelectionPageTKeys["project"] = "GroupSelectionPage.project";
    GroupSelectionPageTKeys["projects"] = "GroupSelectionPage.projects";
    GroupSelectionPageTKeys["projectsAndYards"] = "GroupSelectionPage.projectsAndYards";
    GroupSelectionPageTKeys["repairEquipments"] = "GroupSelectionPage.repairEquipments";
    GroupSelectionPageTKeys["searchProject"] = "GroupSelectionPage.searchProject";
    GroupSelectionPageTKeys["viewDetails"] = "GroupSelectionPage.viewDetails";
    GroupSelectionPageTKeys["workingEquipments"] = "GroupSelectionPage.workingEquipments";
    GroupSelectionPageTKeys["yard"] = "GroupSelectionPage.yard";
    GroupSelectionPageTKeys["yourGroups"] = "GroupSelectionPage.yourGroups";
})(GroupSelectionPageTKeys || (GroupSelectionPageTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var GroupSettingsPageTKeys;
(function (GroupSettingsPageTKeys) {
    GroupSettingsPageTKeys["access"] = "GroupSettingsPage.access";
    GroupSettingsPageTKeys["accessGranted"] = "GroupSettingsPage.accessGranted";
    GroupSettingsPageTKeys["accessSingle"] = "GroupSettingsPage.accessSingle";
    GroupSettingsPageTKeys["account"] = "GroupSettingsPage.account";
    GroupSettingsPageTKeys["active"] = "GroupSettingsPage.active";
    GroupSettingsPageTKeys["addDocumentName"] = "GroupSettingsPage.addDocumentName";
    GroupSettingsPageTKeys["addLocationMarkers"] = "GroupSettingsPage.addLocationMarkers";
    GroupSettingsPageTKeys["addNew"] = "GroupSettingsPage.addNew";
    GroupSettingsPageTKeys["addNewSchedule"] = "GroupSettingsPage.addNewSchedule";
    GroupSettingsPageTKeys["alertsAndNotifications"] = "GroupSettingsPage.alertsAndNotifications";
    GroupSettingsPageTKeys["archiveProject"] = "GroupSettingsPage.archiveProject";
    GroupSettingsPageTKeys["areYouSureArchiveProject"] = "GroupSettingsPage.areYouSureArchiveProject";
    GroupSettingsPageTKeys["cancel"] = "GroupSettingsPage.cancel";
    GroupSettingsPageTKeys["cancelled"] = "GroupSettingsPage.cancelled";
    GroupSettingsPageTKeys["cartrack"] = "GroupSettingsPage.cartrack";
    GroupSettingsPageTKeys["changesSuccessfullySaved"] = "GroupSettingsPage.changesSuccessfullySaved";
    GroupSettingsPageTKeys["clickOrDragToUpload"] = "GroupSettingsPage.clickOrDragToUpload";
    GroupSettingsPageTKeys["clickToAddLocation"] = "GroupSettingsPage.clickToAddLocation";
    GroupSettingsPageTKeys["completed"] = "GroupSettingsPage.completed";
    GroupSettingsPageTKeys["createTrip"] = "GroupSettingsPage.createTrip";
    GroupSettingsPageTKeys["createTripSucess"] = "GroupSettingsPage.createTripSucess";
    GroupSettingsPageTKeys["dailyHours"] = "GroupSettingsPage.dailyHours";
    GroupSettingsPageTKeys["dailyHoursError"] = "GroupSettingsPage.dailyHoursError";
    GroupSettingsPageTKeys["danger"] = "GroupSettingsPage.danger";
    GroupSettingsPageTKeys["delete"] = "GroupSettingsPage.delete";
    GroupSettingsPageTKeys["deleteGeofence"] = "GroupSettingsPage.deleteGeofence";
    GroupSettingsPageTKeys["deleteMaintenanceSchedule"] = "GroupSettingsPage.deleteMaintenanceSchedule";
    GroupSettingsPageTKeys["deleteTripConfirmation"] = "GroupSettingsPage.deleteTripConfirmation";
    GroupSettingsPageTKeys["details"] = "GroupSettingsPage.details";
    GroupSettingsPageTKeys["documentName"] = "GroupSettingsPage.documentName";
    GroupSettingsPageTKeys["documentSuccessfullyUploaded"] = "GroupSettingsPage.documentSuccessfullyUploaded";
    GroupSettingsPageTKeys["documents"] = "GroupSettingsPage.documents";
    GroupSettingsPageTKeys["drawToSetGeofence"] = "GroupSettingsPage.drawToSetGeofence";
    GroupSettingsPageTKeys["edit"] = "GroupSettingsPage.edit";
    GroupSettingsPageTKeys["editDocuments"] = "GroupSettingsPage.editDocuments";
    GroupSettingsPageTKeys["editMachines"] = "GroupSettingsPage.editMachines";
    GroupSettingsPageTKeys["editRequests"] = "GroupSettingsPage.editRequests";
    GroupSettingsPageTKeys["editSettings"] = "GroupSettingsPage.editSettings";
    GroupSettingsPageTKeys["editTimesheets"] = "GroupSettingsPage.editTimesheets";
    GroupSettingsPageTKeys["editUserAccess"] = "GroupSettingsPage.editUserAccess";
    GroupSettingsPageTKeys["emailAddress"] = "GroupSettingsPage.emailAddress";
    GroupSettingsPageTKeys["enterDetails"] = "GroupSettingsPage.enterDetails";
    GroupSettingsPageTKeys["errorOccured"] = "GroupSettingsPage.errorOccured";
    GroupSettingsPageTKeys["failedToUpload"] = "GroupSettingsPage.failedToUpload";
    GroupSettingsPageTKeys["friday"] = "GroupSettingsPage.friday";
    GroupSettingsPageTKeys["fullName"] = "GroupSettingsPage.fullName";
    GroupSettingsPageTKeys["geofence"] = "GroupSettingsPage.geofence";
    GroupSettingsPageTKeys["geofenceSetup"] = "GroupSettingsPage.geofenceSetup";
    GroupSettingsPageTKeys["geofenceUpdated"] = "GroupSettingsPage.geofenceUpdated";
    GroupSettingsPageTKeys["giveUserAccess"] = "GroupSettingsPage.giveUserAccess";
    GroupSettingsPageTKeys["inviteUser"] = "GroupSettingsPage.inviteUser";
    GroupSettingsPageTKeys["maintenanceSchedules"] = "GroupSettingsPage.maintenanceSchedules";
    GroupSettingsPageTKeys["manageUsers"] = "GroupSettingsPage.manageUsers";
    GroupSettingsPageTKeys["monday"] = "GroupSettingsPage.monday";
    GroupSettingsPageTKeys["no"] = "GroupSettingsPage.no";
    GroupSettingsPageTKeys["noDocumentsAvailable"] = "GroupSettingsPage.noDocumentsAvailable";
    GroupSettingsPageTKeys["noSchedulesAdded"] = "GroupSettingsPage.noSchedulesAdded";
    GroupSettingsPageTKeys["notifications"] = "GroupSettingsPage.notifications";
    GroupSettingsPageTKeys["pending"] = "GroupSettingsPage.pending";
    GroupSettingsPageTKeys["phoneNumber"] = "GroupSettingsPage.phoneNumber";
    GroupSettingsPageTKeys["project"] = "GroupSettingsPage.project";
    GroupSettingsPageTKeys["projectDetails"] = "GroupSettingsPage.projectDetails";
    GroupSettingsPageTKeys["projectDocuments"] = "GroupSettingsPage.projectDocuments";
    GroupSettingsPageTKeys["projectSettings"] = "GroupSettingsPage.projectSettings";
    GroupSettingsPageTKeys["removeConfirmation"] = "GroupSettingsPage.removeConfirmation";
    GroupSettingsPageTKeys["removeThisDocument"] = "GroupSettingsPage.removeThisDocument";
    GroupSettingsPageTKeys["revoke"] = "GroupSettingsPage.revoke";
    GroupSettingsPageTKeys["revokeAccess"] = "GroupSettingsPage.revokeAccess";
    GroupSettingsPageTKeys["revokeAccessConfirmation"] = "GroupSettingsPage.revokeAccessConfirmation";
    GroupSettingsPageTKeys["saturday"] = "GroupSettingsPage.saturday";
    GroupSettingsPageTKeys["save"] = "GroupSettingsPage.save";
    GroupSettingsPageTKeys["saveChanges"] = "GroupSettingsPage.saveChanges";
    GroupSettingsPageTKeys["saveGeofence"] = "GroupSettingsPage.saveGeofence";
    GroupSettingsPageTKeys["scheduleDeleted"] = "GroupSettingsPage.scheduleDeleted";
    GroupSettingsPageTKeys["settingsUpdated"] = "GroupSettingsPage.settingsUpdated";
    GroupSettingsPageTKeys["setupTrip"] = "GroupSettingsPage.setupTrip";
    GroupSettingsPageTKeys["showAllGeofences"] = "GroupSettingsPage.showAllGeofences";
    GroupSettingsPageTKeys["status"] = "GroupSettingsPage.status";
    GroupSettingsPageTKeys["submit"] = "GroupSettingsPage.submit";
    GroupSettingsPageTKeys["sunday"] = "GroupSettingsPage.sunday";
    GroupSettingsPageTKeys["supportForSingle"] = "GroupSettingsPage.supportForSingle";
    GroupSettingsPageTKeys["thursday"] = "GroupSettingsPage.thursday";
    GroupSettingsPageTKeys["totalDailyHours"] = "GroupSettingsPage.totalDailyHours";
    GroupSettingsPageTKeys["tripFrom"] = "GroupSettingsPage.tripFrom";
    GroupSettingsPageTKeys["tripName"] = "GroupSettingsPage.tripName";
    GroupSettingsPageTKeys["trips"] = "GroupSettingsPage.trips";
    GroupSettingsPageTKeys["tripsSetup"] = "GroupSettingsPage.tripsSetup";
    GroupSettingsPageTKeys["tuesday"] = "GroupSettingsPage.tuesday";
    GroupSettingsPageTKeys["updateGeofence"] = "GroupSettingsPage.updateGeofence";
    GroupSettingsPageTKeys["updatedTripSuccess"] = "GroupSettingsPage.updatedTripSuccess";
    GroupSettingsPageTKeys["uploadDocument"] = "GroupSettingsPage.uploadDocument";
    GroupSettingsPageTKeys["uploadNew"] = "GroupSettingsPage.uploadNew";
    GroupSettingsPageTKeys["viewAnalytics"] = "GroupSettingsPage.viewAnalytics";
    GroupSettingsPageTKeys["viewTracking"] = "GroupSettingsPage.viewTracking";
    GroupSettingsPageTKeys["wantToDeleteSchedule"] = "GroupSettingsPage.wantToDeleteSchedule";
    GroupSettingsPageTKeys["wantToSaveGeofence"] = "GroupSettingsPage.wantToSaveGeofence";
    GroupSettingsPageTKeys["wednesday"] = "GroupSettingsPage.wednesday";
    GroupSettingsPageTKeys["workingDaysText"] = "GroupSettingsPage.workingDaysText";
    GroupSettingsPageTKeys["yes"] = "GroupSettingsPage.yes";
    GroupSettingsPageTKeys["youCanDrag"] = "GroupSettingsPage.youCanDrag";
})(GroupSettingsPageTKeys || (GroupSettingsPageTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var GroupTrackingPageTKeys;
(function (GroupTrackingPageTKeys) {
    GroupTrackingPageTKeys["action"] = "GroupTrackingPage.action";
    GroupTrackingPageTKeys["activelyWorking"] = "GroupTrackingPage.activelyWorking";
    GroupTrackingPageTKeys["awaitingAcceptance"] = "GroupTrackingPage.awaitingAcceptance";
    GroupTrackingPageTKeys["awaitingApproval"] = "GroupTrackingPage.awaitingApproval";
    GroupTrackingPageTKeys["brokenDown"] = "GroupTrackingPage.brokenDown";
    GroupTrackingPageTKeys["cancelled"] = "GroupTrackingPage.cancelled";
    GroupTrackingPageTKeys["confirmTelematics"] = "GroupTrackingPage.confirmTelematics";
    GroupTrackingPageTKeys["demobilised"] = "GroupTrackingPage.demobilised";
    GroupTrackingPageTKeys["dispatched"] = "GroupTrackingPage.dispatched";
    GroupTrackingPageTKeys["from"] = "GroupTrackingPage.from";
    GroupTrackingPageTKeys["idle"] = "GroupTrackingPage.idle";
    GroupTrackingPageTKeys["inTransit"] = "GroupTrackingPage.inTransit";
    GroupTrackingPageTKeys["inYard"] = "GroupTrackingPage.inYard";
    GroupTrackingPageTKeys["landed"] = "GroupTrackingPage.landed";
    GroupTrackingPageTKeys["machineStatus"] = "GroupTrackingPage.machineStatus";
    GroupTrackingPageTKeys["mechanicDispatched"] = "GroupTrackingPage.mechanicDispatched";
    GroupTrackingPageTKeys["mobilized"] = "GroupTrackingPage.mobilized";
    GroupTrackingPageTKeys["moreInfo"] = "GroupTrackingPage.moreInfo";
    GroupTrackingPageTKeys["name"] = "GroupTrackingPage.name";
    GroupTrackingPageTKeys["noMoreWOrking"] = "GroupTrackingPage.noMoreWOrking";
    GroupTrackingPageTKeys["noTelematicsAvailable"] = "GroupTrackingPage.noTelematicsAvailable";
    GroupTrackingPageTKeys["replaced"] = "GroupTrackingPage.replaced";
    GroupTrackingPageTKeys["requestCreated"] = "GroupTrackingPage.requestCreated";
    GroupTrackingPageTKeys["scheduled"] = "GroupTrackingPage.scheduled";
    GroupTrackingPageTKeys["selectMachines"] = "GroupTrackingPage.selectMachines";
    GroupTrackingPageTKeys["selectProjects"] = "GroupTrackingPage.selectProjects";
    GroupTrackingPageTKeys["telematicsInstalled"] = "GroupTrackingPage.telematicsInstalled";
    GroupTrackingPageTKeys["telematicsUnavailable"] = "GroupTrackingPage.telematicsUnavailable";
    GroupTrackingPageTKeys["to"] = "GroupTrackingPage.to";
    GroupTrackingPageTKeys["underRepair"] = "GroupTrackingPage.underRepair";
    GroupTrackingPageTKeys["viewOnMap"] = "GroupTrackingPage.viewOnMap";
    GroupTrackingPageTKeys["workOrderCreated"] = "GroupTrackingPage.workOrderCreated";
    GroupTrackingPageTKeys["workPaused"] = "GroupTrackingPage.workPaused";
    GroupTrackingPageTKeys["working"] = "GroupTrackingPage.working";
    GroupTrackingPageTKeys["yetToArrive"] = "GroupTrackingPage.yetToArrive";
})(GroupTrackingPageTKeys || (GroupTrackingPageTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var LinkOperatorModalTKeys;
(function (LinkOperatorModalTKeys) {
    LinkOperatorModalTKeys["addOperator"] = "LinkOperatorModal.addOperator";
    LinkOperatorModalTKeys["cancel"] = "LinkOperatorModal.cancel";
    LinkOperatorModalTKeys["chooseOperator"] = "LinkOperatorModal.chooseOperator";
    LinkOperatorModalTKeys["link"] = "LinkOperatorModal.link";
    LinkOperatorModalTKeys["opStartDateMissing"] = "LinkOperatorModal.opStartDateMissing";
    LinkOperatorModalTKeys["projectNotFound"] = "LinkOperatorModal.projectNotFound";
    LinkOperatorModalTKeys["selectOperator"] = "LinkOperatorModal.selectOperator";
    LinkOperatorModalTKeys["selectStartDate"] = "LinkOperatorModal.selectStartDate";
    LinkOperatorModalTKeys["startDate"] = "LinkOperatorModal.startDate";
})(LinkOperatorModalTKeys || (LinkOperatorModalTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var LiveStatTKeys;
(function (LiveStatTKeys) {
    LiveStatTKeys["altitude"] = "LiveStat.altitude";
    LiveStatTKeys["angle"] = "LiveStat.angle";
    LiveStatTKeys["axleLoad"] = "LiveStat.axleLoad";
    LiveStatTKeys["batteryCharging"] = "LiveStat.batteryCharging";
    LiveStatTKeys["batteryVoltage"] = "LiveStat.batteryVoltage";
    LiveStatTKeys["cableConnected"] = "LiveStat.cableConnected";
    LiveStatTKeys["carClosed"] = "LiveStat.carClosed";
    LiveStatTKeys["carClosedByFacory"] = "LiveStat.carClosedByFacory";
    LiveStatTKeys["close"] = "LiveStat.close";
    LiveStatTKeys["createRequest"] = "LiveStat.createRequest";
    LiveStatTKeys["dynamicIgnitionOn"] = "LiveStat.dynamicIgnitionOn";
    LiveStatTKeys["engineCoverOpened"] = "LiveStat.engineCoverOpened";
    LiveStatTKeys["engineHours"] = "LiveStat.engineHours";
    LiveStatTKeys["engineOilLevel"] = "LiveStat.engineOilLevel";
    LiveStatTKeys["engineRPM"] = "LiveStat.engineRPM";
    LiveStatTKeys["engineTemperature"] = "LiveStat.engineTemperature";
    LiveStatTKeys["factorInstalledAlarmIsEmulated"] = "LiveStat.factorInstalledAlarmIsEmulated";
    LiveStatTKeys["factoryInstalledAlarmActuated"] = "LiveStat.factoryInstalledAlarmActuated";
    LiveStatTKeys["footBrakeActivated"] = "LiveStat.footBrakeActivated";
    LiveStatTKeys["footBrakeActivited"] = "LiveStat.footBrakeActivited";
    LiveStatTKeys["frontLeftDoorOpened"] = "LiveStat.frontLeftDoorOpened";
    LiveStatTKeys["frontRightDoorOpened"] = "LiveStat.frontRightDoorOpened";
    LiveStatTKeys["fuelConsumed"] = "LiveStat.fuelConsumed";
    LiveStatTKeys["fuelLevel"] = "LiveStat.fuelLevel";
    LiveStatTKeys["gsmSignal"] = "LiveStat.gsmSignal";
    LiveStatTKeys["handbrakeActivated"] = "LiveStat.handbrakeActivated";
    LiveStatTKeys["hourmeter"] = "LiveStat.hourmeter";
    LiveStatTKeys["ignition"] = "LiveStat.ignition";
    LiveStatTKeys["immobilizerInServiceMode"] = "LiveStat.immobilizerInServiceMode";
    LiveStatTKeys["keyInIgnitionLock"] = "LiveStat.keyInIgnitionLock";
    LiveStatTKeys["latitude"] = "LiveStat.latitude";
    LiveStatTKeys["longitude"] = "LiveStat.longitude";
    LiveStatTKeys["movement"] = "LiveStat.movement";
    LiveStatTKeys["no"] = "LiveStat.no";
    LiveStatTKeys["odometer"] = "LiveStat.odometer";
    LiveStatTKeys["operaorButtonUsed"] = "LiveStat.operaorButtonUsed";
    LiveStatTKeys["parameter"] = "LiveStat.parameter";
    LiveStatTKeys["parkingActivated"] = "LiveStat.parkingActivated";
    LiveStatTKeys["rearLeftDoorOpened"] = "LiveStat.rearLeftDoorOpened";
    LiveStatTKeys["rearRightDoorOpened"] = "LiveStat.rearRightDoorOpened";
    LiveStatTKeys["reverseIsOn"] = "LiveStat.reverseIsOn";
    LiveStatTKeys["satellites"] = "LiveStat.satellites";
    LiveStatTKeys["speed"] = "LiveStat.speed";
    LiveStatTKeys["totalMileage"] = "LiveStat.totalMileage";
    LiveStatTKeys["trunkDoorOpened"] = "LiveStat.trunkDoorOpened";
    LiveStatTKeys["value"] = "LiveStat.value";
    LiveStatTKeys["vehicleWorkingMode"] = "LiveStat.vehicleWorkingMode";
    LiveStatTKeys["webasto"] = "LiveStat.webasto";
    LiveStatTKeys["yes"] = "LiveStat.yes";
})(LiveStatTKeys || (LiveStatTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var LogisticsPageTKeys;
(function (LogisticsPageTKeys) {
    LogisticsPageTKeys["addMoreCargo"] = "LogisticsPage.addMoreCargo";
    LogisticsPageTKeys["back"] = "LogisticsPage.back";
    LogisticsPageTKeys["capacity"] = "LogisticsPage.capacity";
    LogisticsPageTKeys["cargoDetails"] = "LogisticsPage.cargoDetails";
    LogisticsPageTKeys["contactName"] = "LogisticsPage.contactName";
    LogisticsPageTKeys["contactPhone"] = "LogisticsPage.contactPhone";
    LogisticsPageTKeys["dropOffDetails"] = "LogisticsPage.dropOffDetails";
    LogisticsPageTKeys["dropoffLocation"] = "LogisticsPage.dropoffLocation";
    LogisticsPageTKeys["logisticsTrip"] = "LogisticsPage.logisticsTrip";
    LogisticsPageTKeys["makeSureError"] = "LogisticsPage.makeSureError";
    LogisticsPageTKeys["nameOfPerson"] = "LogisticsPage.nameOfPerson";
    LogisticsPageTKeys["next"] = "LogisticsPage.next";
    LogisticsPageTKeys["phoneNumber"] = "LogisticsPage.phoneNumber";
    LogisticsPageTKeys["pickupDate"] = "LogisticsPage.pickupDate";
    LogisticsPageTKeys["pickupDetails"] = "LogisticsPage.pickupDetails";
    LogisticsPageTKeys["pickupLocation"] = "LogisticsPage.pickupLocation";
    LogisticsPageTKeys["pickupTime"] = "LogisticsPage.pickupTime";
    LogisticsPageTKeys["searchDropOffPoint"] = "LogisticsPage.searchDropOffPoint";
    LogisticsPageTKeys["searchPickupPoint"] = "LogisticsPage.searchPickupPoint";
    LogisticsPageTKeys["submit"] = "LogisticsPage.submit";
    LogisticsPageTKeys["successfullyCreated"] = "LogisticsPage.successfullyCreated";
    LogisticsPageTKeys["tripDetails"] = "LogisticsPage.tripDetails";
    LogisticsPageTKeys["tripDistance"] = "LogisticsPage.tripDistance";
    LogisticsPageTKeys["tripDuration"] = "LogisticsPage.tripDuration";
    LogisticsPageTKeys["tripSummary"] = "LogisticsPage.tripSummary";
    LogisticsPageTKeys["vehicleType"] = "LogisticsPage.vehicleType";
    LogisticsPageTKeys["whatWillYouBeTransporting"] = "LogisticsPage.whatWillYouBeTransporting";
})(LogisticsPageTKeys || (LogisticsPageTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var MachineAlertsTabTKeys;
(function (MachineAlertsTabTKeys) {
    MachineAlertsTabTKeys["batteryLevelAlert"] = "MachineAlertsTab.batteryLevelAlert";
    MachineAlertsTabTKeys["date"] = "MachineAlertsTab.date";
    MachineAlertsTabTKeys["default"] = "MachineAlertsTab.default";
    MachineAlertsTabTKeys["duration"] = "MachineAlertsTab.duration";
    MachineAlertsTabTKeys["enableGeofenceAlerts"] = "MachineAlertsTab.enableGeofenceAlerts";
    MachineAlertsTabTKeys["enableHarshDriving"] = "MachineAlertsTab.enableHarshDriving";
    MachineAlertsTabTKeys["engineTemperatureAlert"] = "MachineAlertsTab.engineTemperatureAlert";
    MachineAlertsTabTKeys["event"] = "MachineAlertsTab.event";
    MachineAlertsTabTKeys["eventDetails"] = "MachineAlertsTab.eventDetails";
    MachineAlertsTabTKeys["fuelLevel"] = "MachineAlertsTab.fuelLevel";
    MachineAlertsTabTKeys["fuelTheftAlerts"] = "MachineAlertsTab.fuelTheftAlerts";
    MachineAlertsTabTKeys["geofenceAlerts"] = "MachineAlertsTab.geofenceAlerts";
    MachineAlertsTabTKeys["harshAcceleration"] = "MachineAlertsTab.harshAcceleration";
    MachineAlertsTabTKeys["harshBreaking"] = "MachineAlertsTab.harshBreaking";
    MachineAlertsTabTKeys["idlingLimit"] = "MachineAlertsTab.idlingLimit";
    MachineAlertsTabTKeys["location"] = "MachineAlertsTab.location";
    MachineAlertsTabTKeys["overspeedLimit"] = "MachineAlertsTab.overspeedLimit";
    MachineAlertsTabTKeys["overspeeding"] = "MachineAlertsTab.overspeeding";
    MachineAlertsTabTKeys["previousFuelLevel"] = "MachineAlertsTab.previousFuelLevel";
    MachineAlertsTabTKeys["rpmAlert"] = "MachineAlertsTab.rpmAlert";
    MachineAlertsTabTKeys["threshold"] = "MachineAlertsTab.threshold";
    MachineAlertsTabTKeys["time"] = "MachineAlertsTab.time";
    MachineAlertsTabTKeys["topSpeed"] = "MachineAlertsTab.topSpeed";
    MachineAlertsTabTKeys["upgradeTelematics"] = "MachineAlertsTab.upgradeTelematics";
})(MachineAlertsTabTKeys || (MachineAlertsTabTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var MachineDetailsDrawerTKeys;
(function (MachineDetailsDrawerTKeys) {
    MachineDetailsDrawerTKeys["close"] = "MachineDetailsDrawer.close";
    MachineDetailsDrawerTKeys["createRequest"] = "MachineDetailsDrawer.createRequest";
    MachineDetailsDrawerTKeys["documents"] = "MachineDetailsDrawer.documents";
    MachineDetailsDrawerTKeys["equipmentDetails"] = "MachineDetailsDrawer.equipmentDetails";
    MachineDetailsDrawerTKeys["history"] = "MachineDetailsDrawer.history";
    MachineDetailsDrawerTKeys["location"] = "MachineDetailsDrawer.location";
    MachineDetailsDrawerTKeys["maintenanceHistory"] = "MachineDetailsDrawer.maintenanceHistory";
    MachineDetailsDrawerTKeys["save"] = "MachineDetailsDrawer.save";
    MachineDetailsDrawerTKeys["updateSuccess"] = "MachineDetailsDrawer.updateSuccess";
    MachineDetailsDrawerTKeys["violations"] = "MachineDetailsDrawer.violations";
})(MachineDetailsDrawerTKeys || (MachineDetailsDrawerTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var MachineDocumentsTabTKeys;
(function (MachineDocumentsTabTKeys) {
    MachineDocumentsTabTKeys["download"] = "MachineDocumentsTab.download";
    MachineDocumentsTabTKeys["downloaded"] = "MachineDocumentsTab.downloaded";
    MachineDocumentsTabTKeys["edit"] = "MachineDocumentsTab.edit";
    MachineDocumentsTabTKeys["emailAllDocuments"] = "MachineDocumentsTab.emailAllDocuments";
    MachineDocumentsTabTKeys["expired"] = "MachineDocumentsTab.expired";
    MachineDocumentsTabTKeys["expiresOn"] = "MachineDocumentsTab.expiresOn";
    MachineDocumentsTabTKeys["fileDownloaded"] = "MachineDocumentsTab.fileDownloaded";
    MachineDocumentsTabTKeys["noExpiryDateSet"] = "MachineDocumentsTab.noExpiryDateSet";
    MachineDocumentsTabTKeys["shareByEmail"] = "MachineDocumentsTab.shareByEmail";
    MachineDocumentsTabTKeys["view"] = "MachineDocumentsTab.view";
})(MachineDocumentsTabTKeys || (MachineDocumentsTabTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var MachineHistoryTabTKeys;
(function (MachineHistoryTabTKeys) {
    MachineHistoryTabTKeys["customId"] = "MachineHistoryTab.customId";
    MachineHistoryTabTKeys["date"] = "MachineHistoryTab.date";
    MachineHistoryTabTKeys["detailedHistoryTimeline"] = "MachineHistoryTab.detailedHistoryTimeline";
    MachineHistoryTabTKeys["distanceCovered"] = "MachineHistoryTab.distanceCovered";
    MachineHistoryTabTKeys["engine"] = "MachineHistoryTab.engine";
    MachineHistoryTabTKeys["engineOff"] = "MachineHistoryTab.engineOff";
    MachineHistoryTabTKeys["engineOn"] = "MachineHistoryTab.engineOn";
    MachineHistoryTabTKeys["fuel"] = "MachineHistoryTab.fuel";
    MachineHistoryTabTKeys["fuelLevel"] = "MachineHistoryTab.fuelLevel";
    MachineHistoryTabTKeys["historicMap"] = "MachineHistoryTab.historicMap";
    MachineHistoryTabTKeys["historicStats"] = "MachineHistoryTab.historicStats";
    MachineHistoryTabTKeys["hourmeter"] = "MachineHistoryTab.hourmeter";
    MachineHistoryTabTKeys["ignition"] = "MachineHistoryTab.ignition";
    MachineHistoryTabTKeys["km"] = "MachineHistoryTab.km";
    MachineHistoryTabTKeys["kmH"] = "MachineHistoryTab.kmH";
    MachineHistoryTabTKeys["map"] = "MachineHistoryTab.map";
    MachineHistoryTabTKeys["maxInterval"] = "MachineHistoryTab.maxInterval";
    MachineHistoryTabTKeys["motion"] = "MachineHistoryTab.motion";
    MachineHistoryTabTKeys["no"] = "MachineHistoryTab.no";
    MachineHistoryTabTKeys["noTelematicsInstalled"] = "MachineHistoryTab.noTelematicsInstalled";
    MachineHistoryTabTKeys["odometer"] = "MachineHistoryTab.odometer";
    MachineHistoryTabTKeys["off"] = "MachineHistoryTab.off";
    MachineHistoryTabTKeys["on"] = "MachineHistoryTab.on";
    MachineHistoryTabTKeys["openMap"] = "MachineHistoryTab.openMap";
    MachineHistoryTabTKeys["operator"] = "MachineHistoryTab.operator";
    MachineHistoryTabTKeys["pause"] = "MachineHistoryTab.pause";
    MachineHistoryTabTKeys["replay"] = "MachineHistoryTab.replay";
    MachineHistoryTabTKeys["significant"] = "MachineHistoryTab.significant";
    MachineHistoryTabTKeys["speed"] = "MachineHistoryTab.speed";
    MachineHistoryTabTKeys["stop"] = "MachineHistoryTab.stop";
    MachineHistoryTabTKeys["time"] = "MachineHistoryTab.time";
    MachineHistoryTabTKeys["topSpeed"] = "MachineHistoryTab.topSpeed";
    MachineHistoryTabTKeys["yes"] = "MachineHistoryTab.yes";
})(MachineHistoryTabTKeys || (MachineHistoryTabTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var MachineInfoTabTKeys;
(function (MachineInfoTabTKeys) {
    MachineInfoTabTKeys["capacity"] = "MachineInfoTab.capacity";
    MachineInfoTabTKeys["demobilised"] = "MachineInfoTab.demobilised";
    MachineInfoTabTKeys["emissionClass"] = "MachineInfoTab.emissionClass";
    MachineInfoTabTKeys["equipmentType"] = "MachineInfoTab.equipmentType";
    MachineInfoTabTKeys["linkNewOperator"] = "MachineInfoTab.linkNewOperator";
    MachineInfoTabTKeys["mobile"] = "MachineInfoTab.mobile";
    MachineInfoTabTKeys["mobilised"] = "MachineInfoTab.mobilised";
    MachineInfoTabTKeys["model"] = "MachineInfoTab.model";
    MachineInfoTabTKeys["operator"] = "MachineInfoTab.operator";
    MachineInfoTabTKeys["registration"] = "MachineInfoTab.registration";
    MachineInfoTabTKeys["status"] = "MachineInfoTab.status";
    MachineInfoTabTKeys["year"] = "MachineInfoTab.year";
})(MachineInfoTabTKeys || (MachineInfoTabTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var MachineStatsTKeys;
(function (MachineStatsTKeys) {
    MachineStatsTKeys["engine"] = "MachineStats.engine";
    MachineStatsTKeys["fuel"] = "MachineStats.fuel";
    MachineStatsTKeys["hourmeter"] = "MachineStats.hourmeter";
    MachineStatsTKeys["odometer"] = "MachineStats.odometer";
    MachineStatsTKeys["off"] = "MachineStats.off";
    MachineStatsTKeys["on"] = "MachineStats.on";
    MachineStatsTKeys["speed"] = "MachineStats.speed";
})(MachineStatsTKeys || (MachineStatsTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var MachinesFilterTKeys;
(function (MachinesFilterTKeys) {
    MachinesFilterTKeys["Cancelled"] = "MachinesFilter.Cancelled";
    MachinesFilterTKeys["Demobilised"] = "MachinesFilter.Demobilised";
    MachinesFilterTKeys["Dispatched"] = "MachinesFilter.Dispatched";
    MachinesFilterTKeys["Idle"] = "MachinesFilter.Idle";
    MachinesFilterTKeys["InTransit"] = "MachinesFilter.InTransit";
    MachinesFilterTKeys["InYard"] = "MachinesFilter.InYard";
    MachinesFilterTKeys["Landed"] = "MachinesFilter.Landed";
    MachinesFilterTKeys["MechanicDispatched"] = "MachinesFilter.MechanicDispatched";
    MachinesFilterTKeys["Replaced"] = "MachinesFilter.Replaced";
    MachinesFilterTKeys["Scheduled"] = "MachinesFilter.Scheduled";
    MachinesFilterTKeys["UnderRepair"] = "MachinesFilter.UnderRepair";
    MachinesFilterTKeys["WorkOrderCreated"] = "MachinesFilter.WorkOrderCreated";
    MachinesFilterTKeys["Working"] = "MachinesFilter.Working";
    MachinesFilterTKeys["clearSearch"] = "MachinesFilter.clearSearch";
    MachinesFilterTKeys["search"] = "MachinesFilter.search";
    MachinesFilterTKeys["searchMachine"] = "MachinesFilter.searchMachine";
    MachinesFilterTKeys["selectAll"] = "MachinesFilter.selectAll";
    MachinesFilterTKeys["selectCategory"] = "MachinesFilter.selectCategory";
    MachinesFilterTKeys["selectStatus"] = "MachinesFilter.selectStatus";
    MachinesFilterTKeys["selectTelematics"] = "MachinesFilter.selectTelematics";
    MachinesFilterTKeys["telematicsAvailable"] = "MachinesFilter.telematicsAvailable";
    MachinesFilterTKeys["telematicsUnavailable"] = "MachinesFilter.telematicsUnavailable";
    MachinesFilterTKeys["viewFilters"] = "MachinesFilter.viewFilters";
})(MachinesFilterTKeys || (MachinesFilterTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var MapTabTKeys;
(function (MapTabTKeys) {
    MapTabTKeys["currentSpeed"] = "MapTab.currentSpeed";
    MapTabTKeys["distanceToday"] = "MapTab.distanceToday";
    MapTabTKeys["engine"] = "MapTab.engine";
    MapTabTKeys["engineOilLevel"] = "MapTab.engineOilLevel";
    MapTabTKeys["fuelLevel"] = "MapTab.fuelLevel";
    MapTabTKeys["lastLocation"] = "MapTab.lastLocation";
    MapTabTKeys["lastUpdatedAt"] = "MapTab.lastUpdatedAt";
    MapTabTKeys["liveStats"] = "MapTab.liveStats";
    MapTabTKeys["openInMap"] = "MapTab.openInMap";
    MapTabTKeys["securityFlags"] = "MapTab.securityFlags";
    MapTabTKeys["totalMileage"] = "MapTab.totalMileage";
})(MapTabTKeys || (MapTabTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var MapToolsDropdownTKeys;
(function (MapToolsDropdownTKeys) {
    MapToolsDropdownTKeys["addPaths"] = "MapToolsDropdown.addPaths";
    MapToolsDropdownTKeys["cancel"] = "MapToolsDropdown.cancel";
    MapToolsDropdownTKeys["clusterEq"] = "MapToolsDropdown.clusterEq";
    MapToolsDropdownTKeys["clusterEqDesc"] = "MapToolsDropdown.clusterEqDesc";
    MapToolsDropdownTKeys["distance"] = "MapToolsDropdown.distance";
    MapToolsDropdownTKeys["firstPoint"] = "MapToolsDropdown.firstPoint";
    MapToolsDropdownTKeys["hidePaths"] = "MapToolsDropdown.hidePaths";
    MapToolsDropdownTKeys["mapTools"] = "MapToolsDropdown.mapTools";
    MapToolsDropdownTKeys["measureDistance"] = "MapToolsDropdown.measureDistance";
    MapToolsDropdownTKeys["secondPoint"] = "MapToolsDropdown.secondPoint";
    MapToolsDropdownTKeys["showAllGeofence"] = "MapToolsDropdown.showAllGeofence";
    MapToolsDropdownTKeys["showCustomId"] = "MapToolsDropdown.showCustomId";
    MapToolsDropdownTKeys["showCustomIdDesc"] = "MapToolsDropdown.showCustomIdDesc";
    MapToolsDropdownTKeys["showGroupGeofence"] = "MapToolsDropdown.showGroupGeofence";
    MapToolsDropdownTKeys["showLabels"] = "MapToolsDropdown.showLabels";
    MapToolsDropdownTKeys["showModel"] = "MapToolsDropdown.showModel";
    MapToolsDropdownTKeys["showPaths"] = "MapToolsDropdown.showPaths";
    MapToolsDropdownTKeys["showTraffic"] = "MapToolsDropdown.showTraffic";
})(MapToolsDropdownTKeys || (MapToolsDropdownTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var MyQuotationsTabTKeys;
(function (MyQuotationsTabTKeys) {
    MyQuotationsTabTKeys["agreementSigned"] = "MyQuotationsTab.agreementSigned";
    MyQuotationsTabTKeys["amount"] = "MyQuotationsTab.amount";
    MyQuotationsTabTKeys["approvedAndSigned"] = "MyQuotationsTab.approvedAndSigned";
    MyQuotationsTabTKeys["cancelledOrExpired"] = "MyQuotationsTab.cancelledOrExpired";
    MyQuotationsTabTKeys["capacity"] = "MyQuotationsTab.capacity";
    MyQuotationsTabTKeys["cargo"] = "MyQuotationsTab.cargo";
    MyQuotationsTabTKeys["clickBelowToSee"] = "MyQuotationsTab.clickBelowToSee";
    MyQuotationsTabTKeys["close"] = "MyQuotationsTab.close";
    MyQuotationsTabTKeys["completed"] = "MyQuotationsTab.completed";
    MyQuotationsTabTKeys["contactDetails"] = "MyQuotationsTab.contactDetails";
    MyQuotationsTabTKeys["customInquiries"] = "MyQuotationsTab.customInquiries";
    MyQuotationsTabTKeys["email"] = "MyQuotationsTab.email";
    MyQuotationsTabTKeys["location"] = "MyQuotationsTab.location";
    MyQuotationsTabTKeys["logistics"] = "MyQuotationsTab.logistics";
    MyQuotationsTabTKeys["logisticsTrips"] = "MyQuotationsTab.logisticsTrips";
    MyQuotationsTabTKeys["logisticsType"] = "MyQuotationsTab.logisticsType";
    MyQuotationsTabTKeys["model"] = "MyQuotationsTab.model";
    MyQuotationsTabTKeys["myOrders"] = "MyQuotationsTab.myOrders";
    MyQuotationsTabTKeys["name"] = "MyQuotationsTab.name";
    MyQuotationsTabTKeys["noDescription"] = "MyQuotationsTab.noDescription";
    MyQuotationsTabTKeys["notPlacedOrder"] = "MyQuotationsTab.notPlacedOrder";
    MyQuotationsTabTKeys["order"] = "MyQuotationsTab.order";
    MyQuotationsTabTKeys["orderAccepted"] = "MyQuotationsTab.orderAccepted";
    MyQuotationsTabTKeys["orderCancelled"] = "MyQuotationsTab.orderCancelled";
    MyQuotationsTabTKeys["orderDescription"] = "MyQuotationsTab.orderDescription";
    MyQuotationsTabTKeys["orderHasBeenAccepted"] = "MyQuotationsTab.orderHasBeenAccepted";
    MyQuotationsTabTKeys["orderHasBeenCompleted"] = "MyQuotationsTab.orderHasBeenCompleted";
    MyQuotationsTabTKeys["orderIsPlaced"] = "MyQuotationsTab.orderIsPlaced";
    MyQuotationsTabTKeys["orderPlaced"] = "MyQuotationsTab.orderPlaced";
    MyQuotationsTabTKeys["orderPlacedSuccessfully"] = "MyQuotationsTab.orderPlacedSuccessfully";
    MyQuotationsTabTKeys["payAmount"] = "MyQuotationsTab.payAmount";
    MyQuotationsTabTKeys["paymentSuccessful"] = "MyQuotationsTab.paymentSuccessful";
    MyQuotationsTabTKeys["pending"] = "MyQuotationsTab.pending";
    MyQuotationsTabTKeys["pendingQuotation"] = "MyQuotationsTab.pendingQuotation";
    MyQuotationsTabTKeys["pendingSignature"] = "MyQuotationsTab.pendingSignature";
    MyQuotationsTabTKeys["phoneNumber"] = "MyQuotationsTab.phoneNumber";
    MyQuotationsTabTKeys["placedBy"] = "MyQuotationsTab.placedBy";
    MyQuotationsTabTKeys["quantity"] = "MyQuotationsTab.quantity";
    MyQuotationsTabTKeys["quotationReadyForApproval"] = "MyQuotationsTab.quotationReadyForApproval";
    MyQuotationsTabTKeys["quotationsReceived"] = "MyQuotationsTab.quotationsReceived";
    MyQuotationsTabTKeys["searchForOrders"] = "MyQuotationsTab.searchForOrders";
    MyQuotationsTabTKeys["seeAllOrders"] = "MyQuotationsTab.seeAllOrders";
    MyQuotationsTabTKeys["tenderdProcessingYourOrder"] = "MyQuotationsTab.tenderdProcessingYourOrder";
    MyQuotationsTabTKeys["trackTrip"] = "MyQuotationsTab.trackTrip";
    MyQuotationsTabTKeys["type"] = "MyQuotationsTab.type";
    MyQuotationsTabTKeys["viewProject"] = "MyQuotationsTab.viewProject";
    MyQuotationsTabTKeys["youCanNowTrack"] = "MyQuotationsTab.youCanNowTrack";
    MyQuotationsTabTKeys["youHaveNotPlaceAnyOrder"] = "MyQuotationsTab.youHaveNotPlaceAnyOrder";
})(MyQuotationsTabTKeys || (MyQuotationsTabTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var RecentActivityTKeys;
(function (RecentActivityTKeys) {
    RecentActivityTKeys["recentActivity"] = "RecentActivity.recentActivity";
    RecentActivityTKeys["seeAll"] = "RecentActivity.seeAll";
})(RecentActivityTKeys || (RecentActivityTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var RecentViolationsTKeys;
(function (RecentViolationsTKeys) {
    RecentViolationsTKeys["loading"] = "RecentViolations.loading";
    RecentViolationsTKeys["noRecentViolations"] = "RecentViolations.noRecentViolations";
    RecentViolationsTKeys["recentViolations"] = "RecentViolations.recentViolations";
    RecentViolationsTKeys["speed"] = "RecentViolations.speed";
})(RecentViolationsTKeys || (RecentViolationsTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var ReportsPageTKeys;
(function (ReportsPageTKeys) {
    ReportsPageTKeys["cancel"] = "ReportsPage.cancel";
    ReportsPageTKeys["consumed"] = "ReportsPage.consumed";
    ReportsPageTKeys["dailyFuelReport"] = "ReportsPage.dailyFuelReport";
    ReportsPageTKeys["dailyFuelReportDesc"] = "ReportsPage.dailyFuelReportDesc";
    ReportsPageTKeys["date"] = "ReportsPage.date";
    ReportsPageTKeys["deselectAll"] = "ReportsPage.deselectAll";
    ReportsPageTKeys["distance"] = "ReportsPage.distance";
    ReportsPageTKeys["downloading"] = "ReportsPage.downloading";
    ReportsPageTKeys["emissionsDataAsAggregateDescription"] = "ReportsPage.emissionsDataAsAggregateDescription";
    ReportsPageTKeys["emissionsDataPerDayDescription"] = "ReportsPage.emissionsDataPerDayDescription";
    ReportsPageTKeys["emissionsSummary"] = "ReportsPage.emissionsSummary";
    ReportsPageTKeys["emissionsTimesheet"] = "ReportsPage.emissionsTimesheet";
    ReportsPageTKeys["engineOnHours"] = "ReportsPage.engineOnHours";
    ReportsPageTKeys["fuel"] = "ReportsPage.fuel";
    ReportsPageTKeys["fuelEventReport"] = "ReportsPage.fuelEventReport";
    ReportsPageTKeys["fuelEventReportDesc"] = "ReportsPage.fuelEventReportDesc";
    ReportsPageTKeys["fuelLevel"] = "ReportsPage.fuelLevel";
    ReportsPageTKeys["fuelSummary"] = "ReportsPage.fuelSummary";
    ReportsPageTKeys["fuelSummaryReport"] = "ReportsPage.fuelSummaryReport";
    ReportsPageTKeys["fuelSummaryReportDesc"] = "ReportsPage.fuelSummaryReportDesc";
    ReportsPageTKeys["generate"] = "ReportsPage.generate";
    ReportsPageTKeys["generateReport"] = "ReportsPage.generateReport";
    ReportsPageTKeys["idleEmissions"] = "ReportsPage.idleEmissions";
    ReportsPageTKeys["machine"] = "ReportsPage.machine";
    ReportsPageTKeys["machines"] = "ReportsPage.machines";
    ReportsPageTKeys["model"] = "ReportsPage.model";
    ReportsPageTKeys["numberPlate"] = "ReportsPage.numberPlate";
    ReportsPageTKeys["outputData"] = "ReportsPage.outputData";
    ReportsPageTKeys["refilled"] = "ReportsPage.refilled";
    ReportsPageTKeys["reportsPage"] = "ReportsPage.reportsPage";
    ReportsPageTKeys["selectAll"] = "ReportsPage.selectAll";
    ReportsPageTKeys["selectDateRange"] = "ReportsPage.selectDateRange";
    ReportsPageTKeys["selectFormat"] = "ReportsPage.selectFormat";
    ReportsPageTKeys["selectMachine"] = "ReportsPage.selectMachine";
    ReportsPageTKeys["somethingWentWrong"] = "ReportsPage.somethingWentWrong";
    ReportsPageTKeys["totalEmissions"] = "ReportsPage.totalEmissions";
    ReportsPageTKeys["workingEmissions"] = "ReportsPage.workingEmissions";
})(ReportsPageTKeys || (ReportsPageTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var SendEmailPopoverTKeys;
(function (SendEmailPopoverTKeys) {
    SendEmailPopoverTKeys["emailAddress"] = "SendEmailPopover.emailAddress";
    SendEmailPopoverTKeys["error"] = "SendEmailPopover.error";
    SendEmailPopoverTKeys["fullName"] = "SendEmailPopover.fullName";
    SendEmailPopoverTKeys["send"] = "SendEmailPopover.send";
    SendEmailPopoverTKeys["successfullyShared"] = "SendEmailPopover.successfullyShared";
})(SendEmailPopoverTKeys || (SendEmailPopoverTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var SettingsPageTKeys;
(function (SettingsPageTKeys) {
    SettingsPageTKeys["access"] = "SettingsPage.access";
    SettingsPageTKeys["account"] = "SettingsPage.account";
    SettingsPageTKeys["accountSettings"] = "SettingsPage.accountSettings";
    SettingsPageTKeys["agreements"] = "SettingsPage.agreements";
    SettingsPageTKeys["certificate"] = "SettingsPage.certificate";
    SettingsPageTKeys["changesSuccessfullySaved"] = "SettingsPage.changesSuccessfullySaved";
    SettingsPageTKeys["chinese"] = "SettingsPage.chinese";
    SettingsPageTKeys["company"] = "SettingsPage.company";
    SettingsPageTKeys["companyDetails"] = "SettingsPage.companyDetails";
    SettingsPageTKeys["companyFooter"] = "SettingsPage.companyFooter";
    SettingsPageTKeys["companyHeader"] = "SettingsPage.companyHeader";
    SettingsPageTKeys["companySettings"] = "SettingsPage.companySettings";
    SettingsPageTKeys["countryOverride"] = "SettingsPage.countryOverride";
    SettingsPageTKeys["creditApplication"] = "SettingsPage.creditApplication";
    SettingsPageTKeys["creditApplicationSent"] = "SettingsPage.creditApplicationSent";
    SettingsPageTKeys["dark"] = "SettingsPage.dark";
    SettingsPageTKeys["details"] = "SettingsPage.details";
    SettingsPageTKeys["developer"] = "SettingsPage.developer";
    SettingsPageTKeys["docNotSigned"] = "SettingsPage.docNotSigned";
    SettingsPageTKeys["docSignedApproved"] = "SettingsPage.docSignedApproved";
    SettingsPageTKeys["documents"] = "SettingsPage.documents";
    SettingsPageTKeys["email"] = "SettingsPage.email";
    SettingsPageTKeys["extensions"] = "SettingsPage.extensions";
    SettingsPageTKeys["integrations"] = "SettingsPage.integrations";
    SettingsPageTKeys["inviteMember"] = "SettingsPage.inviteMember";
    SettingsPageTKeys["invitedAgain"] = "SettingsPage.invitedAgain";
    SettingsPageTKeys["language"] = "SettingsPage.language";
    SettingsPageTKeys["light"] = "SettingsPage.light";
    SettingsPageTKeys["localSettings"] = "SettingsPage.localSettings";
    SettingsPageTKeys["localSettingsMessage"] = "SettingsPage.localSettingsMessage";
    SettingsPageTKeys["logout"] = "SettingsPage.logout";
    SettingsPageTKeys["name"] = "SettingsPage.name";
    SettingsPageTKeys["now"] = "SettingsPage.now";
    SettingsPageTKeys["payments"] = "SettingsPage.payments";
    SettingsPageTKeys["phone"] = "SettingsPage.phone";
    SettingsPageTKeys["platformSettings"] = "SettingsPage.platformSettings";
    SettingsPageTKeys["reUpload"] = "SettingsPage.reUpload";
    SettingsPageTKeys["rentalAgreementSent"] = "SettingsPage.rentalAgreementSent";
    SettingsPageTKeys["requestSubmittedSuccessfully"] = "SettingsPage.requestSubmittedSuccessfully";
    SettingsPageTKeys["requestTelematics"] = "SettingsPage.requestTelematics";
    SettingsPageTKeys["requestedTelematics"] = "SettingsPage.requestedTelematics";
    SettingsPageTKeys["resendInvite"] = "SettingsPage.resendInvite";
    SettingsPageTKeys["saveChanges"] = "SettingsPage.saveChanges";
    SettingsPageTKeys["searchSettings"] = "SettingsPage.searchSettings";
    SettingsPageTKeys["settings"] = "SettingsPage.settings";
    SettingsPageTKeys["sidebarTheme"] = "SettingsPage.sidebarTheme";
    SettingsPageTKeys["signAndApprove"] = "SettingsPage.signAndApprove";
    SettingsPageTKeys["somethingWrong"] = "SettingsPage.somethingWrong";
    SettingsPageTKeys["teamDetails"] = "SettingsPage.teamDetails";
    SettingsPageTKeys["trackingNotAvailable"] = "SettingsPage.trackingNotAvailable";
    SettingsPageTKeys["tradeLicense"] = "SettingsPage.tradeLicense";
    SettingsPageTKeys["upload"] = "SettingsPage.upload";
    SettingsPageTKeys["uploadForReports"] = "SettingsPage.uploadForReports";
    SettingsPageTKeys["uploadToVerify"] = "SettingsPage.uploadToVerify";
    SettingsPageTKeys["userDetails"] = "SettingsPage.userDetails";
    SettingsPageTKeys["userSettings"] = "SettingsPage.userSettings";
    SettingsPageTKeys["usersAndAccess"] = "SettingsPage.usersAndAccess";
    SettingsPageTKeys["verificationPending"] = "SettingsPage.verificationPending";
    SettingsPageTKeys["verified"] = "SettingsPage.verified";
    SettingsPageTKeys["viewFooter"] = "SettingsPage.viewFooter";
    SettingsPageTKeys["viewHeader"] = "SettingsPage.viewHeader";
    SettingsPageTKeys["waitingForVerification"] = "SettingsPage.waitingForVerification";
})(SettingsPageTKeys || (SettingsPageTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var SideBarTKeys;
(function (SideBarTKeys) {
    SideBarTKeys["chatSupport"] = "SideBar.chatSupport";
    SideBarTKeys["extensions"] = "SideBar.extensions";
    SideBarTKeys["helpAndSupport"] = "SideBar.helpAndSupport";
    SideBarTKeys["login"] = "SideBar.login";
    SideBarTKeys["logistics"] = "SideBar.logistics";
    SideBarTKeys["marketplace"] = "SideBar.marketplace";
    SideBarTKeys["myMachines"] = "SideBar.myMachines";
    SideBarTKeys["myOrders"] = "SideBar.myOrders";
    SideBarTKeys["myRequests"] = "SideBar.myRequests";
    SideBarTKeys["settings"] = "SideBar.settings";
    SideBarTKeys["signup"] = "SideBar.signup";
    SideBarTKeys["tendering"] = "SideBar.tendering";
    SideBarTKeys["trackProjects"] = "SideBar.trackProjects";
    SideBarTKeys["unverifiedAccount"] = "SideBar.unverifiedAccount";
    SideBarTKeys["verifiedAccount"] = "SideBar.verifiedAccount";
})(SideBarTKeys || (SideBarTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var UtilizationGraphTKeys;
(function (UtilizationGraphTKeys) {
    UtilizationGraphTKeys["checkAll"] = "UtilizationGraph.checkAll";
    UtilizationGraphTKeys["date"] = "UtilizationGraph.date";
    UtilizationGraphTKeys["dateRangeLimit"] = "UtilizationGraph.dateRangeLimit";
    UtilizationGraphTKeys["fuelConsumed"] = "UtilizationGraph.fuelConsumed";
    UtilizationGraphTKeys["fuelConsumption"] = "UtilizationGraph.fuelConsumption";
    UtilizationGraphTKeys["hours"] = "UtilizationGraph.hours";
    UtilizationGraphTKeys["requestFuelTracking"] = "UtilizationGraph.requestFuelTracking";
    UtilizationGraphTKeys["telematics"] = "UtilizationGraph.telematics";
    UtilizationGraphTKeys["timekeeper"] = "UtilizationGraph.timekeeper";
    UtilizationGraphTKeys["youDontHaveFuel"] = "UtilizationGraph.youDontHaveFuel";
})(UtilizationGraphTKeys || (UtilizationGraphTKeys = {}));
// DONT EDIT THIS FILE. AUTOGENERATED. 
export var ViolationsModalTKeys;
(function (ViolationsModalTKeys) {
    ViolationsModalTKeys["filteredViolationsResult"] = "ViolationsModal.filteredViolationsResult";
    ViolationsModalTKeys["violations"] = "ViolationsModal.violations";
})(ViolationsModalTKeys || (ViolationsModalTKeys = {}));
